'use strict';
var focusHelper = require('../components/focus');
var startCarousel = require('../ah-carousel');
var debounce = require('lodash/debounce');
var validateImage = require('../components/validateImage');
var scrollAnimate = require('../components/scrollAnimate');

 function klaviyoAddToCartEvent(klaviyoCartEventURL) {
    //Klaviyo track AddToCart event
      $.ajax({
          url: klaviyoCartEventURL,
          method: 'GET',
          success: function () {
            //cart event tracked. No action needed
          }
       });
   }

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;

    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length) {
        pid = $($el).closest('.modal-content').find('.product-quickview').data('pid');
    } else if ($el.closest('.shop-component').length > 0) {
        pid = $($el).closest('.product-detail').find('.product-id').text();
    } else {
        pid = $($el).closest('.product-detail').find('.main-product').find('.product-id').text();
    }

    return pid;
}

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getGiftCardStatus($el) {
    var gcs;

    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length) {
        gcs = $($el).closest('.modal-content').find('.product-quickview').data('gc');
    } else {
        gcs = $($el).closest('.product-detail').data('gc');
    }

    return gcs;
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    return $el && ($('.set-items').length || $('.product-detail').length) ?
        $($el).closest('.product-detail').find('.quantity-select') :
        $('.quantity-select');
}

function selectNextAttr(attribute) {
    return new Promise(function (resolve, reject) {
        if (attribute == null) { return };

        // set one at a time so we get previous attr into URL to avoid timing issue
        var value = attribute.find('.js-items-attr .selectable').data('displayvalue');

        if (value && value.length > 0) {
            var selectAttribute = attribute.find('select.js-select-attr option[data-displayvalue="' + value + '"]');
            var optionValue = selectAttribute.attr('value');
            if (optionValue) {
                attribute.find('select.js-select-attr').selectpicker('val', optionValue);
                attribute.removeClass('js-attrNotSelected');
            }
            resolve();
        }
    });
}

function initSelectNextAttr() {
    var notSelectedAttrs = $('.js-attrNotSelected[data-attrname="Color"]');
    if (notSelectedAttrs && notSelectedAttrs.length > 0) {
        var attribute = $(notSelectedAttrs[0]);

        selectNextAttr(attribute);
    }
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    return getQuantitySelector($el).val();
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    var titleSet = false;
    var optionSet = true;
    var optionsChanged = false;
    var selectedValue;

    var $swatchselecter = $productContainer.find('[data-attr="' + attr.id + '"] .swatch-picker');
    var $variantselecter = $productContainer.find('[data-attr="' + attr.id + '"] select.swatch-picker');

    attr.values.forEach(function (attrValue) {
        var $attrLabel = $productContainer.find('.' + attr.id + ".js-label .js-replace");
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' +
            attrValue.value + '"]');
        var $swatchButton = $attrValue.parent();

        if (attrValue.selected) {
            selectedValue = attrValue.id;

            $swatchButton.attr('aria-pressed', true);
            $attrValue.addClass('selected');
            $swatchButton.addClass('selected');
            if ($swatchButton.length) {
                var SelectedAriaLabel = $($swatchButton).attr('aria-label').replace('Selectable', 'Selected');
                $($swatchButton).attr('aria-label', SelectedAriaLabel);
            }
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);

            if (!titleSet) {
                var newName = attrValue.displayValue;
                if(attr.id !== 'Theme'){
                    newName = newName.split(' ').slice(1).join(' '); //Removing the initial color code and showing only the Color Name
                }
                $attrLabel.html(newName);
                titleSet = true;
                optionSet = false;
            }
        } else {
            $attrValue.removeClass('selected');
            $swatchButton.removeClass('selected');
            $swatchButton.removeAttr('aria-pressed');
            if ($swatchButton.length) {
                var SelectedAriaLabel = $($swatchButton).attr('aria-label').replace('Selected', 'Selectable');
                $($swatchButton).attr('aria-label', SelectedAriaLabel);
            }
            $attrValue.siblings('.selected-assistive-text').empty();
        }

        if (!titleSet) {
            $attrLabel.text("Please choose a " + attr.displayName.toLowerCase());
        }

        if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url);
        } else {
            $swatchButton.removeAttr('data-url');
        }

        var $variantSelectorOption = null;

        if ($variantselecter) {
            $variantSelectorOption = $variantselecter.find('option[data-displayvalue="' + attrValue.displayValue + '"]');
        }

        var $attrAriaLabel = $swatchButton.attr('aria-label') || '';
        // Disable if not selectable
        $swatchButton.removeClass('selectable unselectable');
        $swatchButton.removeAttr('disabled');
        $attrAriaLabel = $attrAriaLabel.replace(/Selectable|Unselectable|Selected/g, '').trim().replace(/\s+/g, ' ');
        $swatchButton.addClass(attrValue.selectable ? 'selectable' : 'unselectable');
        if (attrValue.selectable) {
            if ($swatchButton.length > 0) {
                $attrAriaLabel = 'Selectable ' + $attrAriaLabel;
            }
            if ($variantSelectorOption) {
                $variantSelectorOption.removeAttr('disabled');
            }
        } else {
            if($swatchButton.length > 0) {
                $attrAriaLabel = 'Unselectable ' + $attrAriaLabel;
            }
            if ($variantSelectorOption) {
                $variantSelectorOption.prop('disabled', true);
            }

            // keep OOS swatches disabled for bonus products
            if($swatchButton.parents('.bonus-product-item').length) {
                $swatchButton.prop('disabled', true);
            }
        }
        if ($swatchButton.hasClass('selected')) {
            $attrAriaLabel = 'Selected ' + $attrAriaLabel;
        }
        $swatchButton.attr('aria-label', $attrAriaLabel);
    });

    if ($swatchselecter) {
        $swatchselecter.selectpicker('refresh');
    }

    return optionsChanged;
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
    var titleSet = false;
    var optionSet = true;
    var optionSelect;
    var optionsChanged = false;
    var selectedValue;

    var $variantselecter = $productContainer.hasClass('coordinating-product') ? $productContainer.find('[data-attr="' + attr.id + '"] select.variant-picker') : $productContainer.find('[data-attr="' + attr.id + '"] select.variant-picker').filter(function() {
        return $(this).parents('.coordinating-product').length === 0;
    });
    attr.values.forEach(function (attrValue) {
        var $attrLabel = $productContainer.find('.' + attr.id + ".js-label .js-replace");
        var $adaText = $productContainer.find('.' + attr.id + ".js-label .adaText");
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '-other"] [data-attr-value="' +
            attrValue.value + '"]').first(); // prints have coordinating items that will return multiple attributes within main product container, only first element should be updated
        var $swatchButton = $attrValue.parent();
        var $attrFitstyle = $attrValue.closest('.attribute').attr('data-sizefitstyle');

        if (attrValue.selected) {
            $attrValue.parent().addClass('selected');
            selectedValue = attrValue.displayValue;
            var SelectedAriaLabel;
            if ($attrValue.parent().length > 0) {
                SelectedAriaLabel = $attrValue.parent().attr('aria-label').replace('Selectable', 'Selected');
            }
            $attrValue.parent().attr('aria-label', SelectedAriaLabel);

            if (!titleSet) {
                var newName = attrValue.displayValue;
                var adaName = newName.replace('XXS', 'Extra Extra Small').replace('XSM', 'Extra Small').replace('SML', 'Small').replace('MED', 'Medium').replace('LGE', 'Large').replace('XLG', 'Extra Large').replace('XL', ' Extra Large').replace('W ', ' Women ').replace('M ', ' Men ');

                if ($attrFitstyle) {
                    newName = "<span class='fitstyle'>" + $attrFitstyle + "</span> - " + newName;
                    adaName = $attrFitstyle + ' '+ adaName;
                }

                $attrLabel.html(newName);
                $adaText.html($adaText.data('attrtext') + ' '+ adaName);
                titleSet = true;
                optionSet = false;
            }

        } else {
            $attrValue.parent().removeClass('selected');
            var SelectedAriaLabel;
            if ($attrValue.parent().length > 0) {
                SelectedAriaLabel = $attrValue.parent().attr('aria-label').replace('Selected', 'Selectable');
            }

            $attrValue.parent().attr('aria-label', SelectedAriaLabel);
            $attrValue.siblings('.selected-assistive-text').empty();
        }

        if (!titleSet) {
            $attrLabel.text("Please choose a " + attr.displayName.toLowerCase());
        }

        if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url);
        } else {
            $swatchButton.removeAttr('data-url');
        }

        // Disable if not selectable
        $swatchButton.removeClass('selectable unselectable');
        $swatchButton.removeAttr('disabled');
        $swatchButton.addClass(attrValue.selectable ? 'selectable' : 'unselectable');
        var $attrAriaLabel = $swatchButton.attr('aria-label') || '';
        $attrAriaLabel = $attrAriaLabel.replace(/Selectable|Unselectable|Selected/g, '').trim().replace(/\s+/g, ' ');
        $swatchButton.addClass(attrValue.selectable ? 'selectable' : 'unselectable');

        // Check if select dropdown
        var $variantSelectorOption = null;
        if ($variantselecter) {
            $variantSelectorOption = $variantselecter.find('option[data-displayvalue="' + attrValue.displayValue + '"]');
        }

        if (attrValue.selectable) {
            if ($swatchButton.length > 0) {
                $attrAriaLabel = 'Selectable ' + $attrAriaLabel;
            }
            if ($variantSelectorOption) {
                $variantSelectorOption.removeAttr('disabled');
            }
        } else {
            if($swatchButton.length > 0) {
                $attrAriaLabel = 'Unselectable ' + $attrAriaLabel;
            }

            if ($variantSelectorOption) {
                $variantSelectorOption.prop('disabled', true);
            }

            // keep OOS swatches disabled for bonus products
            if($swatchButton.parents('.bonus-product-item').length) {
                $swatchButton.prop('disabled', true);
            }
        }
        if ($swatchButton.hasClass('selected')) {
            $attrAriaLabel = 'Selected ' + $attrAriaLabel;
        }
        $swatchButton.attr('aria-label', $attrAriaLabel);
    });

    if ($variantselecter) {
        $variantselecter.selectpicker('refresh');
    }

    return optionsChanged;
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, data) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ['color', 'Theme', 'COLORS'];
    var swatchValues;
    var nonSwatchValues;
    var optionsChanged = false;

    attrs.forEach(function (attr) {
        if (new RegExp(attrsWithSwatches.join("|")).test(attr.id)) {
            swatchValues = processSwatchValues(attr, $productContainer, data.resources);
        } else {
            nonSwatchValues = processNonSwatchValues(attr, $productContainer);
        }
    });

    if (swatchValues == true || nonSwatchValues == true) {
        optionsChanged = true;
    }

    return optionsChanged;
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var availabilityValue = '';
    var availabilityMessages = response.product.availability.messages;
    if (!response.product.readyToOrder) {
        availabilityValue = response.resources.info_selectforstock;
    } else {
        availabilityMessages.forEach(function (message) {
          if (message.indexOf("pre-order") > -1) {
            message = ", " + message;
          }
          availabilityValue += message;
        });
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
}

/**
 * Shows/hides display message on PDP
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateDisplayMsg(response, $productContainer) {
    var displayMessage = response.product && response.product.displayMessage ? response.product.displayMessage : null;
    if (displayMessage && displayMessage.length && response.product.productType != "master") {
        $productContainer.find('.product-message').first().removeClass('d-none').html(displayMessage);
        if (!$productContainer.find('.prod-addToBag-wrapper').hasClass('with-message')) {
            $productContainer.find('.prod-addToBag-wrapper').addClass('with-message');
        }
    } else if (!displayMessage) {
        $productContainer.find('.product-message').addClass('d-none').html('');
        if ($productContainer.find('.prod-addToBag-wrapper').hasClass('with-message')) {
            $productContainer.find('.prod-addToBag-wrapper').removeClass('with-message');
        }
    } else return;
}


/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    var html = '';

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach(function (attribute) {
                html += '<div class="attribute-values">' + attribute.label + ': ' +
                    attribute.value + '</div>';
            });
        }
    });

    return html;
}

/**
 * @typedef UpdatedOptionValue
 * @type Object
 * @property {string} id - Option value ID for look up
 * @property {string} url - Updated option value selection URL
 */

/**
 * @typedef OptionSelectionResponse
 * @type Object
 * @property {string} priceHtml - Updated price HTML code
 * @property {Object} options - Updated Options
 * @property {string} options.id - Option ID
 * @property {UpdatedOptionValue[]} options.values - Option values
 */

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
    // Update options
    $productContainer.find('.product-options').empty().html(optionsHtml);
}

/**
 * Dynamically creates slick slider from response containing images
 * @param {Object[]} data - ajax response data
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {String} overlayImage - Overlay image of product
 */
var flag = 0;
var videoContainer;

function UpdateCarousel(data, $productContainer) {
    var alternativeImagesAvailable = data.altImagesAvailable;
    var overlayImage = data.product.overlayImage || null;
    var productAddons = data.product.addOns || null;
    var carousel = $productContainer.find('.prod-slider');
    var activePersonalization = false;
    var onerrorScript = "this.src='" + data.product.missingImage + "'";

    if ($('.new-pdp-layout-carousel').length > 0 && $(window).width() < 768) {
        if (flag === 0) {
            var ifrmaeObject = $('.new-pdp-layout-carousel, .new-pdp-layout-carousel1').find('.wistia_responsive_padding');
           if ( $(ifrmaeObject).length > 0) {
            videoContainer = $(ifrmaeObject).clone();
           } else {
            videoContainer =   $('.new-pdp-layout-carousel, .new-pdp-layout-carousel1').find('.wistia_responsive_wrapper').first().clone();
           }
            flag = 1;
        }
    }

    $(carousel).each(function () {
        if (!$(this).hasClass('js-currentActive')) {
            var sliderID = $(this).attr('id');
            if (!$(this).hasClass('new-pdp-layout-carousel') || $(window).width() < 768) {
                if ($(this).find('.slick-track button').length > 0) {
                    $(this).find('.slick-track').empty();
                }

                for (var i = 0; i < alternativeImagesAvailable.length; i++) {
                    if (alternativeImagesAvailable[i].mobile && $(this).hasClass('pdp-carousel-thumbnails')) {
                        // pdp thumbnail image navigation
                        $(this).slick('slickAdd', '<button type="button" class="prod-slider__item zoomit btn-base"><img src="' + alternativeImagesAvailable[i].thumbnail + '" class="d-block" alt="' + (alternativeImagesAvailable[i].alt ? alternativeImagesAvailable[i].alt.split("|")[0].trim() : '') + ' image number ' + parseInt(alternativeImagesAvailable[i].index, 10) + '" title="' + (alternativeImagesAvailable[i].title ? alternativeImagesAvailable[i].title.split("|")[0].trim() : '') + '" itemprop="image" onerror="' + onerrorScript + '"/></button>');
                    } else if (alternativeImagesAvailable[i].mobile && ($(this).hasClass('pdp-carousel-main') || $(this).hasClass('bonus-pdp-carousel-main'))) {
                        // main product image
                        var notabIndex = 'tabindex="-1"';
                        if ($(this).hasClass('new-pdp-layout-carousel')) {
                            $(this).slick('slickAdd', '<button type="button" class="prod-slider__item zoomit btn-base"><img src="' + alternativeImagesAvailable[i].url + '" data-imagezoom="' + alternativeImagesAvailable[i].url + '" class="lazy d-block" alt="' + (alternativeImagesAvailable[i].alt ? alternativeImagesAvailable[i].alt.split("|")[0].trim() : '') + ' image number ' + parseInt(alternativeImagesAvailable[i].index, 10) + '" title="' + (alternativeImagesAvailable[i].title ? alternativeImagesAvailable[i].title.split("|")[0].trim() : '') + '" itemprop="image" onerror="' + onerrorScript + '"/></button>');
                        } else {
                            $(this).slick('slickAdd', '<button type="button" ' + notabIndex + ' class="prod-slider__item zoomit btn-base"><img src="' + alternativeImagesAvailable[i].mobile + '" data-imagezoom="' + alternativeImagesAvailable[i].url + '" class="lazy d-block" alt="' + (alternativeImagesAvailable[i].alt ? alternativeImagesAvailable[i].alt.split("|")[0].trim() : '') + ' image number ' + parseInt(alternativeImagesAvailable[i].index, 10) + '" title="' + (alternativeImagesAvailable[i].title ? alternativeImagesAvailable[i].title.split("|")[0].trim() : '') + '" itemprop="image" onerror="' + onerrorScript + '"/></button>');
                        }
                    } else if ($('#' + sliderID + '[class*="nav"]').length > 0) {
                        // image navigation
                        if (!$('.wistia-video-active').length > 0) { // if both wistia and youtube video are configured . youtube video thumbanial creation handled babsed on wistia video configured or not
                            var altText;
                            if (alternativeImagesAvailable[i] && alternativeImagesAvailable[i].index) {
                                altText = "image number " + parseInt(alternativeImagesAvailable[i].index, 10);
                            } else {
                                altText = "Product Video";
                            }
                            $(this).slick('slickAdd', '<button type="button" class="prod-slider__item btn-base"><img src="' + alternativeImagesAvailable[i].playThumbnail + '" class="d-block" alt="' + altText + '" itemprop="image" onerror="' + onerrorScript + '"/></div>');
                        }
                    } else {
                        // main product image - video                        
                        if (!$('#quickViewModal.show').length > 0 && !$('.wistia-video-active').length > 0 && !$('.medelita-pdp-layout').length > 0) {
                            var videoIframe = data.altVideos.videos[0].videoMain;                        
                            $(this).slick('slickAdd', '<div class="prod-slider__item video_item"><div class="wistia_responsive_padding" ><div class="wistia_responsive_wrapper"> ' + videoIframe + ' </div></div></div>');

                        } else {
                            if (!$('.wistia-video-active').length > 0 &&  !$('.medelita-pdp-layout').length > 0) {
                                $(this).slick('slickAdd', '<div class="prod-slider__item"><button class="video-modal-toggle" tabindex="-1" data-toggle="modal" data-target="#product-video-modal-id-' + data.product.masterPID + '"><img src="' + alternativeImagesAvailable[i].backGroundImage + '" class="videobg-image d-block" alt="image number ' + parseInt(alternativeImagesAvailable[i].index, 10) + '" itemprop="image" /><img src="' + alternativeImagesAvailable[i].playVideoIcon + '" class="videobg-icon d-block" alt="image number ' + parseInt(alternativeImagesAvailable[i].index, 10) + '" itemprop="image" onerror="' + onerrorScript + '"/></button></div>');
                            }                            
                        }       

                        if ($('.modal.video-modal').length > 0 && $('button.video-modal-toggle').length > 0 && !$('.wistia-video-active').length > 0 && !$('.medelita-pdp-layout').length > 0) {
                            $('button.video-modal-toggle').attr('data-target', '#product-video-modal-id-' + $(this).attr('data-product-id'));
                        }
                    }
                    
                }

            } else {
                if (!$('body').hasClass('pageLoad')) { // this condition is not to call UpdateCarousel function on page load to improve page performance
                    $('body').addClass('pageLoad');
                } else {
                    if ($('button.color-attribute').hasClass('selected') || $('button.selection-button').hasClass('selected')) {
                        var videoHTMLContent;
                        if ($('.wistia_responsive_padding').length > 0) {
                            $(this).find('button:nth-child(2)').css('min-height', $('.new-pdp-layout-carousel').find('button:last-child').outerHeight());
                            videoHTMLContent = $('.wistia_responsive_padding').closest('button').first().html();
                        }
                        $(this).find('button').remove();
                        for (var i = 0; i < alternativeImagesAvailable.length; i++) {
                            if (alternativeImagesAvailable[i].mobile && $(this).hasClass('pdp-carousel-main')) {
                                var count = 1;
                                var orderBtn = i === 1 ? 'order-' + parseInt(alternativeImagesAvailable.length + 1, 10) : 'order-' + parseInt(count + i, 10);
                                var btn = '<button type="button" class="prod-slider__item zoomit btn-base ' + orderBtn + '"><img src="' + alternativeImagesAvailable[i].url + '" data-imagezoom="' + alternativeImagesAvailable[i].url + '" class="lazy d-block" alt="' + (alternativeImagesAvailable[i].alt ? alternativeImagesAvailable[i].alt.split("|")[0].trim() : '') + ' image number ' + parseInt(alternativeImagesAvailable[i].index, 10) + '" title="' + (alternativeImagesAvailable[i].title ? alternativeImagesAvailable[i].title.split("|")[0].trim() : '') + '" itemprop="image" onerror="' + onerrorScript + '"/></button>';
                                $(btn).appendTo($(this));
                                if ($('.wistia_responsive_padding').length > 0) {
                                    setTimeout(function () {
                                        $('.new-pdp-layout-carousel').find('button:nth-child(2)').removeAttr('style');
                                    }, 300);
                                }
                            }
                        }
                        if ($('.wistia_responsive_padding').length > 0) {
                            var vidBtn = '<button type="button" class="prod-slider__item zoomit btn-base order-sm-2">' + videoHTMLContent + '</button>';
                            $(vidBtn).appendTo($(this));
                        }
                    }
                }
            }

            // Personalization
            var isQuickview = $(this).closest('.product-quickview') && $(this).closest('.product-quickview').length > 0 ? true : false;
            if (productAddons && !isQuickview) {
                var personalizationThumbnail = productAddons.personalizationThumbnail;
                if (personalizationThumbnail && personalizationThumbnail.length) {
                    if ($('#' + sliderID + '[class*="nav"]').length > 0) {
                        // image navigation
                        $(this).slick('slickAdd', '<button type="button" id="personalization1Icon" class="prod-slider__item"><img src="' + productAddons.personalizationThumbnail + '" class="d-block" alt="Personalization image number ' + (alternativeImagesAvailable.length + 1) + '" title="Personalize" itemprop="image" onerror="' + onerrorScript + '"/></button>');
                    } else {
                        // main product image
                        var personalizationSlider = '<div id="personalization1image" class="prod-slider__item personalization-image" style="background-color:white;"> <div id="personalization1" class="personalization-image__1"></div>';

                        // Add second image if available
                        if (productAddons.engraving.secondaryImage) {
                            personalizationSlider += '<div id="personalization2" class="personalization-image__2"></div> <div class="personalization-image__text bold">Tube Engraving Preview</div>';
                        }

                        personalizationSlider += '</div>';

                        if (!$('.new-pdp-layout-carousel').length > 0 || $(window).width() < 768) {
                            $(this).slick('slickAdd', personalizationSlider);
                        }
                    }
                }
            }
        } else {
            activePersonalization = true;
        }

        if ($('.wistia-video-active').length > 0 && !$('.new-pdp-layout-carousel').length > 0) {
             if (!$(this).hasClass('pdp-carousel-thumbnails')) {
                var wistiavideoIframe = $('.wistia_responsive_wrapper iframe').attr('src');  
                // Create the iframe with dynamic src
                var videoIframe = '<iframe src="' + wistiavideoIframe + '" allow="autoplay; fullscreen" allowtransparency="true" frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" allowfullscreen msallowfullscreen width="100%" height="100%"></iframe>';
                $(this).slick('slickAdd', '<div class="prod-slider__item video_item"><div class="wistia_responsive_padding" ><div class="wistia_responsive_wrapper"> ' +  videoIframe + ' </div></div></div>');
             } else {
                var videoHTMLContent = $('.wistia_responsive_padding').closest('button').first().html();
                $(this).slick('slickAdd', '<button type="button" class="prod-slider__item video_item prod-slider__item zoomit btn-base order-sm-2"></button>');
             }  
        }
    });

    

    if ($('.new-pdp-layout-carousel').length > 0 && $(window).width() < 768 && $(videoContainer).first().text().length > 0 && !($('.wistia_responsive_padding').length || $('.wistia_responsive_wrapper').length)) {
         var videoslideritem;
        if ($(videoContainer).find('.wistia_responsive_wrapper').length > 0) {
             videoslideritem = '<button type="button" class="prod-slider__item zoomit btn-base">' + $(videoContainer).first().html() + '</button>';
            $('.prod-slider.new-pdp-layout-carousel').slick('slickAdd', videoslideritem, true);    
        } else {
            var videoHTML = '<div class="wistia_responsive_wrapper"> ' + $(videoContainer).first().html() + '</div>';
             videoslideritem = '<button type="button" class="prod-slider__item zoomit btn-base">' + videoHTML + '</button>';    
              $('.prod-slider.new-pdp-layout-carousel').slick('slickAdd', videoslideritem);     
        }
    }

    // trigger engraving img and data
    if (!activePersonalization) {
        if ($('.js-engravingData') && $('.js-engravingData').length > 0) {
            $('.js-engravingData').blur();
        }

        // Overlay Image
        if (overlayImage && overlayImage.length > 0) {
            var $firstImage = carousel.find('.prod-slider__item').first();
            $firstImage.append($('<img src=' + overlayImage + ' class="overlay-image">'));
        }
    }
}

function validateAttributeSelection(attributes, container) {
    var result = true;
    var attributeUpdated = container && container.find('.js-coordinating-checkbox').length ?
                            container.find('.product-detail .js-attributes .attribute') : 
                            (container && container.hasClass('js-main-product') ? $('.product-detail .js-main-product .js-attributes .attribute') : "") ;
    if (attributes && attributes.length > 0) {
        $.each(attributes, function () {
            var selected = $(this).find('.selected.selectable');
            if (selected && selected.length == 0) {
                result = false;
                return false;
            }
        });
    } else if (attributeUpdated && (attributeUpdated.find('button.selected').length !== attributeUpdated.length)) {
        return false;
    }

    return result;
}

function validateCoordinatingItems() {
    var result = true;

    if ($('.coordinating-items__details') && $('.coordinating-items__details').length > 0) {
        var items = $('.coordinating-items__details').find('.js-coordinating-checkbox');

        $.each(items, function () {
            var isChecked = this.checked;
            if (isChecked) {
                var itemAttributes = $(this).closest('.item__products__info').find('.js-items-attr');
                if (itemAttributes && itemAttributes.length > 0) {
                    var checkAttr = validateAttributeSelection(itemAttributes, $('.coordinating-items__details'));
                    if (checkAttr === false) {
                        result = false;
                        return false;
                    }
                }
            }
        });
    }

    return result;
}

function validateRecAddons() {
    var result = true;

    if ($('.rec-addons .product') && $('.rec-addons .product').length > 0) {
        var items = $('.rec-addons .product').find('.addon-checkbox');

        $.each(items, function () {
            var isChecked = this.checked;
            if (isChecked) {
                var itemAttributes = $(this).closest('.product').find('.js-items-attr');
                if (itemAttributes && itemAttributes.length > 0) {
                    var checkAttr = validateAttributeSelection(itemAttributes, $('.rec-addons .product'));
                    if (checkAttr === false) {
                        result = false;
                        return false;
                    }
                }
            }
        });
    }

    return result;
}

function validateAddToCartButton(container) {
    var addToCartBtn = $('.add-to-cart');
    var attributes = $('.js-attributes .main-product .js-attribute');
    var isQuickView = false;
    var checkMainProduct = false;
    var checkCoordinatingItems = false;
    var checkRecAddons = false;
    var quantitySelectContainer = $('.prod-addToBag-wrapper .cart-item-qty');

    // If quickview then get add to cart button and attributes from quickview modal
    if (container && container.length) {
        if (container.parent('.bonus-product-item').length > 0) {
            addToCartBtn= container.parent('.bonus-product-item').find('.js-select-bonus-product')
        } else {
            addToCartBtn = (container.hasClass('js-match-set-tile')) ? container.find('.js-match-set-add-to-cart') : container.find('.add-to-cart');
        }

        if (container.hasClass('product-wrapper')) {
            attributes = container.find('.js-attributes .attribute');
        } else {
            attributes = container.find('.js-attributes .main-product .js-attribute');
        }

        quantitySelectContainer = container.find('.prod-addToBag-wrapper .cart-item-qty');

        if (container.hasClass('product-quickview')) {
            isQuickView = true;
        }
    }

    checkMainProduct = validateAttributeSelection(attributes, container);

    if (!isQuickView) {
        checkCoordinatingItems = validateCoordinatingItems();
        checkRecAddons = validateRecAddons();
    } else {
        checkCoordinatingItems = true; // Make this true for quickView
        checkRecAddons = true; // Make this true for quickView
    }

    if (!checkMainProduct || !checkCoordinatingItems || !checkRecAddons) {
        addToCartBtn.prop('disabled', true);
        quantitySelectContainer.addClass('disabled').removeClass('enabled').find('> button, > input').prop('disabled', true);
    } else {
        addToCartBtn.removeAttr('disabled');
        if (container && container.closest('.bonus-product-item').length > 0) {
            container.find('.js-select-bonus-product').removeAttr('disabled');
        }

        quantitySelectContainer.removeClass('disabled').addClass('enabled').find('> button, > input').removeAttr('disabled');
    }

    // Keep Co-ordinating item checkbox disabled until user select all the attributes
    if (container && container.find('.js-coordinating-checkbox').length > 0) {
        let checkboxContainer = container.find('.item__products__variation div.js-select-attr');
        let allAttrSelected = true;

        checkboxContainer.each(function () {
            if (($(this).find('.filter-option-inner-inner').html() === 'Select Size') || ($(this).find('.filter-option-inner-inner').html() === 'Select Inseam')) {
                allAttrSelected = false;
            }
        });

        if (allAttrSelected) {
            container.find('.item__checkbox__wrapper .js-coordinating-checkbox').removeAttr('disabled');
        }
    }
}

function updateButtonText(isQuickView, $productContainer, isVariant) {
    var quickViewBtn = $('.product-quickview .add-to-cart');
    var allAttributeSelected = true;
    var buttonText = "";
    var addToCartBtn;

    if ($productContainer && $productContainer.hasClass('product-wrapper')) {
        addToCartBtn = $productContainer.find('.add-to-cart');
    } else {
        addToCartBtn = $('.product-detail .add-to-cart-cta .add-to-cart');
    }

    if (isQuickView) {
        $('.product-quickview .js-attributes .attribute').not('.engraving').each(function () {
            if ($(this).find('button.selected').length === 0) {
                buttonText = 'Select ' + $(this).attr('data-attrname');
                quickViewBtn.text(buttonText);
                allAttributeSelected = false;
                return false;
            }
        });
    } else if ($productContainer && $productContainer.hasClass('product-wrapper')) {
        $($productContainer.find('.js-attributes .attribute')).not('.engraving').each(function () {
            if ($(this).find('button.selected').length === 0) {
                buttonText = 'Select ' + $(this).attr('data-attrname');
                addToCartBtn.text(buttonText);
                allAttributeSelected = false;
                return false;
            }
        });
    } else {
        // Do not consider engraving as an attribute
        $('.product-detail .product-attribute-section .js-attributes .attribute').not('.engraving').each(function () {
            if ($(this).find('button.selected').length === 0) {
                buttonText = 'Select ' + $(this).attr('data-attrname');
                addToCartBtn.text(buttonText);
                allAttributeSelected = false;
                return false;
            }
        });
    }

    if (!allAttributeSelected) {
        if (!addToCartBtn.prop('disabled')) {
            addToCartBtn.prop('disabled', true);
        }
    }

    if ($('.rc-shop-container .product.product-detail').length > 0) {
        let recProducts;

        if ($productContainer) {
            recProducts = $productContainer;
        } else {
            recProducts = $('.product.product-detail');
        }

        recProducts.each(function () {
            addToCartBtn = $(this).find('.add-to-cart');
            $(this).find('.js-attributes .attribute').each(function () {
                if ($(this).find('button.selected').length === 0) {
                    buttonText = 'Select ' + $(this).attr('data-attrname');
                    addToCartBtn.text(buttonText);
                    return false;
                } else {
                    // If there is only one attribute and that is also selected, we are changing the text to add to bag.
                    buttonText = $('.add-to-cart-text').val();
                    addToCartBtn.text(buttonText);
                }
            });
        })
    }

    if (allAttributeSelected) {
        updateTextForAddToBagButton(isQuickView, $productContainer, isVariant);
    } else {
        //To remove availability message if all attributes are not selected
        $('.product-attribute-section .availability-msg').empty();
        $('.js-availability-msg-personalize').addClass('hide');
    }
}

/**
 * To update product link for signin scenario data persist
 * @param $productContainer - Product container selector
 * @param responseUrl - Product URl contains swatch and options params
 * @returns void
 */
function updateProductLink($productContainer, responseUrl) {
	if ($($productContainer).find('.product-details-link')) {
        var productLink = responseUrl;

        var parseUrl = productLink.split('?');
        var baseUrl = parseUrl[0];
        var params = parseUrl[1];
        var paramList = params?.length ? params.split('&') : '';
        var newParams = [];
        /* Remove options related params and keep others */
        paramList.forEach(function (param) {
            if (param.indexOf('dwopt') < 0) {
            	newParams.push(param);
            }
        });
        var newParamsString = newParams.join('&');
        var newUrl = baseUrl + '?' + newParamsString;

		$($productContainer).find('.product-details-link').attr(
            'value',
            newUrl
        );
    }
}

function addToBagTextChange($productContainer, isVariant) {
    var initialProdQty, newButtonText;
    var $addToBagCta = $productContainer ? $productContainer.find('button.add-to-cart') : $('.add-to-cart.update-cart');
    var returnToBagText = $addToBagCta.attr('data-returntobag');
    var updateItemText = $addToBagCta.attr('data-updateitem');
    var initialProdId = $addToBagCta.attr('data-pid');
    var currentProdQty = parseInt($('.js-quantityContainer').find('.quantity-input').val());
    var isProductChanged = false;
    var isQtyChanged = false;
    var currentProdId;
    var isProductUnavailable = $addToBagCta.attr('data-unavailable');
    var notifyMeText = $addToBagCta.attr('data-notifyme');
    var soldOutText = $addToBagCta.attr('data-soldout');

    currentProdId = localStorage.getItem("currentProdId");
    initialProdQty = parseInt(localStorage.getItem("initialProdQty"));
    // cartQty = parseInt(localStorage.getItem("cartQty"));

    if (currentProdId !== initialProdId) {
        isProductChanged = true;
    }

    if (initialProdQty === null || isNaN(initialProdQty)) {
        localStorage.setItem("initialProdQty", currentProdQty);
    } else if (initialProdQty !== currentProdQty) {
        isQtyChanged = true;
    }

    /* Change add to cart button text if we change any personalisation data while coming from cart*/
    if ($('.page').data('action') === 'Cart-GetProduct') {
        var $embroideryset = $('.embroideryset');
        var isPersDataChanged = false;

        if ($('.embroidery').length > 0) {
            $embroideryset.each(function () {
                if ($(this).find('.data-embroidery').val() !== '[]' && $(this).find('.cart-embroidery').val() !== $(this).find('.data-embroidery').val()) {
                    isPersDataChanged = true;
                    return false;
                }
            });
        }
    }

    // if variant is non-existent or offline, set the text as 'sold out'
    // this is for SKUs that are non-reorderable
    if (isVariant !== undefined && !isVariant) {
        newButtonText = soldOutText;
    } else {
        if (isProductUnavailable) {
            newButtonText = notifyMeText;
        } else if (isProductChanged || isQtyChanged || isPersDataChanged) {
            newButtonText = updateItemText;
        } else {
            newButtonText = returnToBagText;
        }
    }

    return newButtonText;
}

function updateTextForAddToBagButton(isQuickView, $productContainer, isVariant) {
    var addToCartBtn;
    if (isQuickView) {
        addToCartBtn = $('.product-quickview .add-to-cart');
    } else if ($productContainer && $productContainer.hasClass('product-wrapper')) {
        addToCartBtn = $productContainer.find('.add-to-cart');
    } else {
        addToCartBtn = $('.product-detail .add-to-cart-cta .add-to-cart');
    }
    var buttonText = $('.add-to-cart-text').val();
    var updatedButtonText;

    updatedButtonText = addToBagTextChange($productContainer, isVariant);
    // if updatedButtonText is undefined, text for pdp-addToBag does not get correctly updated
    if (updatedButtonText === undefined) {
        addToCartBtn.text(buttonText);
    } else {
        addToCartBtn.text(updatedButtonText);
    }

    if (addToCartBtn.attr('data-unavailable')) {
        addToCartBtn.prop('disabled', false);
    }
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer, updatePrice) {
    var optionsChanged = false;
    var isChoiceOfBonusProducts = $productContainer.hasClass('choice-of-bonus-product');
    var isVaraint;
    if (response.product.variationAttributes) {
        // Show selected attribute name
        updateAttrs(response.product.variationAttributes, $productContainer, response);
        isVaraint = response.product.productType === 'variant';

        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item').data('pid', response.product.id);
            $productContainer.parent('.bonus-product-item').data('ready-to-order', response.product.readyToOrder);
        }
    }

    //check if an upcharge should display beside selected attribute name
    var upchargeValues = [
        { 'attribute': 'color', 'price': response.product.variationUpchargeByColor },
        { 'attribute': 'size', 'price': response.product.variationUpchargeBySize }
    ];

    if (!$('#addToCartModal').hasClass('show')) {
        productUpchargeValues(upchargeValues, $productContainer);
    }

    var btnContainer = $productContainer.find('input.quantity-input');

    if (response.product.variationAttributes && (response.product.available || (response.product.maxOrderQuantity > 0 && parseInt(btnContainer.val()) <= parseInt(btnContainer.attr('value'))))) {
        $productContainer.find("button.add-to-cart").removeAttr('data-unavailable');
    } else {
        $productContainer.find("button.add-to-cart").attr('data-unavailable', true);
        var attrsWithSwatches = ['color', 'Theme', 'COLORS'];
        response.product.variationAttributes.forEach(function (attr) {
            attr.values.forEach(function (attrValue) {
                var $attrSpan = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' + attrValue.value + '"]').first(); // prints have coordinating items that will return multiple attributes within main product container, only first element should be updated
                var $attrButton = $attrSpan.parent();
                var isSwatch = new RegExp(attrsWithSwatches.join("|")).test(attr.id);
                if (attrValue.selected) {
                    $attrButton.addClass('selected');
                    if (isSwatch) {
                        $attrSpan.addClass('selected');
                    }
                } else {
                    $attrButton.removeClass('selected');
                    if (isSwatch) {
                        $attrSpan.removeClass('selected');
                    }
                }
                if (attrValue.url) {
                    $attrButton.attr('data-url', attrValue.url);
                } else {
                    $attrButton.removeAttr('data-url');
                }
            });
        });
    }

    if (!$productContainer.hasClass('js-isAddOnProduct')) {
        // Update engraving image data
        if ($productContainer.find('.engraving') && response.product.addOns && response.product.addOns.engraving) {
            if ($productContainer.find('.js-primaryImage')) {
                $productContainer.find('.engraving .js-primaryImage').empty().text(response.product.addOns.engraving.primaryImage);
            }
            if ($productContainer.find('.js-secondaryImage')) {
                $productContainer.find('.engraving .js-secondaryImage').empty().text(response.product.addOns.engraving.secondaryImage);
            }
        }

        if ($('.onlyForMobile-pdp-gallery .pdp-carousel-main').length > 0 && $(window).width() < 768) {
             setTimeout(function () {
                var carouselItemHeight = $('.onlyForMobile-pdp-gallery .pdp-carousel-main').outerHeight();
                $('.onlyForMobile-pdp-gallery .pdp-carousel-main').css('min-height', carouselItemHeight);
                if ($('.onlyForMobile-pdp-gallery .pdp-carousel-main iframe.wistia_embed').length > 0) {
                    $('.onlyForMobile-pdp-gallery .pdp-carousel-main iframe.wistia_embed').addClass('d-flex');
                }
            }, 500);
        }

        if ($('#quickViewModal.show').length > 0) {
            setTimeout(function () {
                UpdateCarousel(response, $productContainer);
            }, 500);
        } else {            
            var isRemovePositionClicked = $(document).data('removePositionClicked');
            if (!($('.js-addEmbroidery:focus').length > 0) && !($('.selection-button:focus').length > 0) && !$('.js-select-graphic').hasClass('selected') && !isRemovePositionClicked) {
                UpdateCarousel(response, $productContainer);
            } else {
                if($('.color-attribute:focus').length > 0) {
                    UpdateCarousel(response, $productContainer);
                }
            }
            
            if (isRemovePositionClicked) {
                $(document).data('removePositionClicked', false);
            }
        }

        updateAvailability(response, $productContainer);

        updateDisplayMsg(response, $productContainer);

        // Update attributes
        $productContainer.find('.main-attributes').empty()
            .html(getAttributesHtml(response.product.attributes));

        // Update max quantity available
        var quantityContainer = $productContainer.find('.quantity-select');
        var qtyValue = quantityContainer.val();
        quantityContainer.attr('data-max', response.product.maxOrderQuantity);
        quantityContainer.attr('data-plimax', response.product.pliMaxQuantity);

        if (qtyValue != 1) {
            validateQuantity(quantityContainer);
        } else if (response.product.maxOrderQuantity > qtyValue) {
            if ($('.page').data('action') === 'Product-Show' && !quantityContainer.parents('.modal').length) {
                $('.js-pdpQtyError').parent().remove();
            } else {
                $('.js-pdpQtyError').parent();
            }
            $('.pdp-gallery-section').removeClass('extended-top');
        }
    } else if (response.product.images && response.product.images.large) {
        // Update Recommendation Add-Ons image
        var image = response.product.images.large[0].mobile;
        $('.image-container img', $productContainer).prop('src', image);
    }

    updateProductLink($productContainer, response.product.selectedProductUrl);

    // Update pricing
    if (!isChoiceOfBonusProducts && updatePrice) {
        var $priceSelector = $productContainer.find('.price').length
            ? $productContainer.find('.price').first()
            : $('.prices .price').first();
        $priceSelector.replaceWith(response.product.price.html);    
    }

    if (!isChoiceOfBonusProducts) {
        validateAddToCartButton($productContainer);
    } else {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
    }

    validateImage.validatePictures();

    return optionsChanged;
}

/**
 * To Build a new URL that has all the personalization options selected - to be used for price update on PDP
 * @param {object} optionsJSON - personalization options returned from getOptions().
 * @return {string} - Product-Variation URL with options value
 */
function buildOptionsURL(optionsJSON, swatchUrl) {
    var mainOptionsContainer = $('.js-mainOptions');
    var url = '';

    if (mainOptionsContainer && mainOptionsContainer.length) {
        if (mainOptionsContainer.find('.js-embroideryLine1').length) {
            url = mainOptionsContainer.find('.js-embroideryLine1 option[data-value-id=none]').attr('value');
        } else if (mainOptionsContainer.find('.js-Engraving.Head').length) {
            url = mainOptionsContainer.find('.js-Engraving.Head option[data-value-id=none]').attr('value');
        } else if (mainOptionsContainer.find('.js-Engraving.Tube').length) {
            url = mainOptionsContainer.find('.js-Engraving.Tube option[data-value-id=none]').attr('value');
        } else if (mainOptionsContainer.find('.js-Engraving.Handle').length) {
            url = mainOptionsContainer.find('.js-Engraving.Handle option[data-value-id=none]').attr('value');
        }
    }

    var parseUrl = url && url.length ? url.split('?') : [];
    var baseUrl = parseUrl[0];
    var params = parseUrl[1];
    var paramList = params?.length ? params.split('&') : [];
    var newParams = [];
    paramList.forEach(function (param) {
        if (param.indexOf('dwopt') > -1) {
            optionsJSON.forEach(function (option) {
                if (param.indexOf(option.optionId) !== -1) {
                    var paramValue = param.split('=')[1];
                    var parseParam = param.replace(paramValue, option.selectedValueId);
                    newParams.push(parseParam);
                }
            });
        } else if (!swatchUrl){
            newParams.push(param);
        }
    });
    var newParamsString = newParams.join('&');
    var newUrl = swatchUrl ? swatchUrl + '&' + newParamsString : baseUrl + '?' + newParamsString;
    return newUrl;
}

function reselectOptions($productContainer, selectedValueUrl) {
    // reselect items
    var embroidery = $productContainer.find(".js-addEmbroidery");
    var emblemGraphic = $productContainer.find(".js-select-graphic");
    var yourSavedLogos = $productContainer.find(".js-select-ALgraphic");
    var customLogoResponse = $productContainer.find(".js-customLogoResponse");
    var engraving = $productContainer.find(".js-addEngraving");
    var optionsChanged = false;

    if (embroidery.length) {
        embroidery.each(function (e) {
            var thisInput = $(this);
            if (thisInput.val().trim() !== '') {
                var embLine = thisInput.data('line');
                var set = thisInput.data('set');

                if (set == '2') {
                    embLine = parseInt(embLine) + 3;
                }

                //Update option selection
                var thisOption = $('select.js-embroideryLine' + embLine + ' option[data-value-id=line' + embLine + ']');
                if (!thisOption.attr('selected')) {
                    thisOption.prop('selected', true);
                    optionsChanged = true;
                }
            }
        });
    }

    if (emblemGraphic.length) {
        emblemGraphic.each(function (e) {
            if ($(this).hasClass('selected')) {
                var selectedPrice = $(this).data('price');
                var set = $(this).data('set');

                //Update option selection
                var thisGraphicOption = $('select.js-graphic' + set + ' option[data-value-id="' + selectedPrice + '"]');
                if (!thisGraphicOption.attr('selected')) {
                    thisGraphicOption.prop('selected', true);
                    optionsChanged = true;
                }

                $(this).blur();
            }
        });
    }

    if (customLogoResponse.length) {
        customLogoResponse.each(function () {
            var customLogoPrice = $(this).attr('data-custom-logo-price');
            var customLogoSet = $(this).attr('data-custom-logo-set');

            if (customLogoPrice && customLogoSet) {
                //Update option selection
                var thisCustomLogoOption = $('select.js-graphic' + customLogoSet + ' option[data-value-id="' + customLogoPrice + '"]');

                if (!thisCustomLogoOption.attr('selected')) {
                    thisCustomLogoOption.prop('selected', true);
                    optionsChanged = true;
                }
            }
        });
    }

    // check for saved logos
    if (yourSavedLogos.length) {
        yourSavedLogos.each(function (e) {
            if ($(this).hasClass('selected')) {
                var selectedPrice = $(this).data('price');
                var set = $(this).data('set');

                //Update option selection
                var thisGraphicOption = $('select.js-graphic' + set + ' option[data-value-id="' + selectedPrice + '"]');
                if (!thisGraphicOption.attr('selected')) {
                    thisGraphicOption.prop('selected', true);
                    optionsChanged = true;
                }

                $(this).blur();
            }
        });
    }

    if (engraving.length) {
        engraving.each(function () {
            var input = $(this);
            var inputOptionID = input.data('option');
            var inputPrice = input.data('price');
            var inputValue = $(this).val().trim();
            var thisSelect = $productContainer.find('[data-option-id=' + inputOptionID + ']');
            var currentOption = thisSelect.find('select.js-Engraving :selected');
            var currentOptionSelectedPrice = currentOption.data('price');

            if (inputValue && inputValue.length > 0) {
                $productContainer.find('[data-option-id=' + inputOptionID + '] .js-Engraving option[data-price="' + inputPrice + '"]').prop('selected', true);

                if (currentOptionSelectedPrice != inputPrice) {
                    optionsChanged = true;
                }
            } else {
                $productContainer.find('[data-option-id=' + inputOptionID + '] .js-Engraving option[data-price="$0.00"]').prop('selected', true);
            }
            $('.prod-slider').removeClass('js-currentActive');
        });
    }
    optionsChanged = ($('.editembroset').length || $('.js-done-btn').hasClass('applied')) ? false : optionsChanged;
    return optionsChanged;
}

function processAttributeSelect(data, selectedValueUrl, $productContainer, isQuickView, focusedEle, isfocused, scrollTop) {
    var optionsChanged = false;
    var isVariant = true;
    if (data.product) {
        isVariant = (data.product.id === data.product.masterPID) ? false : isVariant;
    }
    updateOptions(data.product.optionsHtml, $productContainer);
    var variantResponse = handleVariantResponse(data, $productContainer, true);
    if (variantResponse == true) {
        optionsChanged = true;
    }
    $('body').trigger('product:afterAttributeSelect', {
        data: data,
        container: $productContainer
    });

    // Avoid price update "flickering"
    if (optionsChanged == false) {
        // Only update the correct price element of the container
        // Avoid price update "flickering" for quickView modal
        if (!isQuickView) {
            var $priceElements = $productContainer.find('.price');
            if ($priceElements.length > 1) {
                $priceElements.each(function () {
                    // adding check for co-ordinating items
                    if (!$(this).parents('.coordinating-product').length) {
                        $($(this), $productContainer).replaceWith(data.product.price.html);
                    }
                });
            } else {
                $($productContainer.find('.price'), $productContainer).replaceWith(data.product.price.html);
            }
        } else if (isQuickView && typeof (data) !== 'undefined' && typeof (data.product.price.html) !== 'undefined') {
            // Update price only when attributes are selected in quickbuy
            $productContainer.find('.price').replaceWith(data.product.price.html);
        }

        // Update tiered price
        if (data.product.priceTiered && data.product.priceTiered.html) {
            $productContainer.find('.price-tiered').empty().html(data.product.priceTiered.html);
            $productContainer.find('.price-tiered').show();
        } else {
            $productContainer.find('.price-tiered').hide();
        }
    }

    if (focusedEle && focusedEle.length && isfocused) {
        focusedEle[0].focus();
    }

    localStorage.setItem("currentProdId", data.product.id);

    if (!$productContainer.hasClass('coordinating-product')) { // do not change ATC button text upon attribute selection of coordinating items
        updateButtonText(isQuickView, $productContainer, isVariant);
    }
    if(isQuickView && $(window).width() < 768 && selectedValueUrl.includes('Variation')){
        $('#quickViewModal')[0].scrollTo({
            top: scrollTop
        });
    }
    // update data-href of qty element for availability check
    var $pdpQtyCard = $productContainer.find('.js-quantityCard');

    $pdpQtyCard.attr('data-href', selectedValueUrl);
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer, result, fullcolorname, mainProdSwatchClicked) {
    var isfocused = $('.js-addEmbroidery').is(':focus');
    var focusedEle = $(':focus');
    var isQuickView = ($productContainer.hasClass('product-quickview') && !$productContainer.closest('.choice-of-bonus-product'));
    var scrollTop = $("#quickViewModal").scrollTop();

    if (!isQuickView && $('.product-options .product-option').length > 0) {
    	var selectedOptions = getOptions($productContainer);
    	var optionsJSON = JSON.parse(selectedOptions);
    	selectedValueUrl = buildOptionsURL(optionsJSON, selectedValueUrl);
    } else if (!isQuickView && ($('.page').data('action') === 'Cart-GetProduct' || $('.page').data('action') === 'Order-GetProduct') && !$('.product-options .product-option').length && !$productContainer.parents('.rc-shop-container').length) {
        // should trigger a Product-Variation call only for edit product that is not eligible for personalization
        if (!selectedValueUrl) {
            var pid = $('.product-detail').attr('data-pid');
            var variationURL = $('.color-attribute').first().length > 0 ? $('.color-attribute').first().attr('data-url').split('?')[0] : ($('.color-attribute').first().length > 0 ? $('.color-attribute').first().attr('data-url').split('?')[0] : '');
            selectedValueUrl = pid && variationURL.length ? variationURL + '?pid=' + pid : null;
        }
    } else if (!selectedValueUrl && $('.page').data('action') === 'Product-Show' && !$('.product-options .product-option').length && $('.color-attribute').length) {
    	selectedValueUrl = location.origin + $('.color-attribute.color-selection').data('url').split('?')[0];
    	if ($('.page').data('querystring') != '') {
    		selectedValueUrl = selectedValueUrl + '?' + $('.page').data('querystring');
    	}
    }
    if (selectedValueUrl) {
        if ($productContainer.hasClass('js-match-set-tile')) {
            //For match set recommendation
            return processMatchSetAttributeSelect(selectedValueUrl, $productContainer);
        } else if ($productContainer.hasClass('js-product-rec-tile')) {
            // For gridTileAddToCart product recs tile
            return processTileAttributeSelect(selectedValueUrl, $productContainer).then(function (data) {
                if ($('.checkout-path').length) {
                    initSelectNextAttr();
                }
            });
        } else {
            // make synchronous ajax call if embro flow cancelled, otherwise keep async as true
            // if async is false for all scenarios, it is giving a jittery UI experience
            // isCancel is only set when an embro flow is edited and cancelled, if user cancels before adding any data, this flag is not set
            var async = true;
            async = localStorage.isCancel ? false : true;

            // check if response is returned for the selected variant or for its master
            // master will be returned in case variant is offline/non-existent

            // also check if this function is invoked from color selection or other attr selection
            var isNotColorClick = result && result.target && (result.target.classList.contains('size-value') || result.target.classList.contains('inseam-value') || result.target.classList.contains('other-attribute')) ? true : false;
            return new Promise(function (resolve, reject) {
                if (result && 'isQuickViewResult' in result && result.isQuickViewResult) {
                    processAttributeSelect(result, selectedValueUrl, $productContainer, isQuickView, focusedEle, isfocused, scrollTop);
                    resolve(result);
                    if ($('body').hasClass('swatchSelected')) {
                        $.spinner().stop();
                        $('body').removeClass('swatchSelected');
                    }
                } else {
                    // if swatch is auto-selected on page load
                    if((mainProdSwatchClicked || $('.js-main-product').find('.swatch-circle.selected').length) && fullcolorname === undefined) {
                        fullcolorname = $('.js-main-product').find('.swatch-circle.selected').parents('button').length ? $('.js-main-product').find('.swatch-circle.selected').parents('button').attr('data-fulldisplayvalue') : null;
                    }
                    $.ajax({
                        url: selectedValueUrl,
                        method: 'GET',
                        async: async,
                        data: {
                            fullcolorname:fullcolorname,
                            mainProdSwatchClicked:mainProdSwatchClicked,
                            isNotColorClick:isNotColorClick
                        },
                        success: function (data) {
                            processAttributeSelect(data, selectedValueUrl, $productContainer, isQuickView, focusedEle, isfocused, scrollTop);
                            resolve(data);
                        },
                        error: function (err) {
                            $.spinner().stop();
                            reject(err);
                        },
                        complete: function(data) {
                            if ($('body').hasClass('swatchSelected')) {
                                $.spinner().stop();
                                $('body').removeClass('swatchSelected')
                            }

                            // Recommandation PDP products main image and swatch selection
                            var data = data.responseJSON;
                            if (data && data.enablePdpRecommendationsColorSync) {
                                if ($('.main-product button.color-attribute').hasClass('colorSwatchSelected') || $('.main-product').find('.swatch-circle.selected').length) {
                                    if (!isNotColorClick && data.filteredRecommandationProducts.length > 0) {
                                        updateRecProductImage(data);
                                    } else showDefaultOrColorImage();
                                } else {
                                    showDefaultOrColorImage();
                                }
                            }

                            if ($('button.color-attribute').hasClass('colorSwatchSelected')) {
                                $('button.color-attribute').removeClass('colorSwatchSelected')
                            }
                        }
                    });
                }
            });
        }
    }
}

/**
 * To show default product image/color image on swatch selection
 */
function showDefaultOrColorImage() {
    let recommandationProduct = $('.rc-shop-container .product-wrapper.product-detail');
    recommandationProduct.each(function(index , product){
        if ($(product).find('img.img-responsive').length > 0 && $(product).find('button.color-swatches').hasClass('colorSwatchSelected')) {
            $(product).find('img.img-responsive').remove();
            $(product).find('picture, img ').removeClass('d-none');
        }
    });
}

/**
 * To update (sync) tile image of recommendations with selected color
 * @param {Object} data - ajax response data
 */
function updateRecProductImage(data) {
    let $recommandationProducts = $('.rc-shop-container .product-wrapper.product-detail');
    $recommandationProducts.each(function(index , product){
        var isSelected = false;
        if ($(this).find('.color-price button.color-swatches, .color-price .color-swatches span.selection_swatch_color').hasClass('selected')) {
            isSelected = true;
        }
        $(this).find('.color-price button.color-swatches, .color-price .color-swatches span.selection_swatch_color').removeClass('selected ');
        var swatchColor = data.filteredRecommandationProducts[index]['color'];
        let $selectedColorSwatch = $(this).children().find('button.selectable[data-displayvalue="'+swatchColor+'"]');
        $selectedColorSwatch.addClass('selected');
        $selectedColorSwatch.children('span:first()').addClass('selected');

        if ($selectedColorSwatch.length && data.filteredRecommandationProducts[index] !== undefined && data.filteredRecommandationProducts[index]['image'] !== undefined) {
            if ($(product).attr('data-pid') === data.filteredRecommandationProducts[index]['id']) {
                $(product).find('picture, img ').addClass('d-none');
                $(product).find('img.img-responsive').remove();
                var $img = $('<img>', {
                    src: data.filteredRecommandationProducts[index]['image'],
                    class: 'img-responsive'
                    });
                $img.appendTo($(product).find('.image-container__link'));

                if (data.filteredRecommandationProducts[index] !== undefined && data.filteredRecommandationProducts[index]['variationAttributes']) {
                    const filteredArray = Object.values(data.filteredRecommandationProducts[index]['variationAttributes']).filter(obj => {
                        return Object.keys(obj).length > 0;
                    });
                    updateAttrs(filteredArray, $(product), {resources: {assistiveSelectedText: "selected"}});
                }
            }
        } else {
            if ($(product).attr('data-pid') === data.filteredRecommandationProducts[index]['id']) {
                $(product).find('img.img-responsive').remove();
                $(product).find('picture, img').removeClass('d-none');
                $(product).find('img').attr('src', $(product).find('img').attr('data-imgpath'));
                $(product).find('source').attr('srcset', $(product).find('img').attr('data-imgpath'));
            }
        }

        var colorName = $selectedColorSwatch.attr('data-displayvalue');
        if (colorName !== undefined) {
            $selectedColorSwatch.parents('.js-attribute').find('.js-replace.js-color-replace').text(colorName.split(' ').slice(1).join(' '));
        } else $(this).find('.js-attribute .js-replace.js-color-replace').text("Please choose a color");

        var text = null;
	    var discountFlag = true; // to be used for sale/clearance discount class

        // pass only color data of specific product, do not pass entire ajax response
        var colorData;
        var $priceContainer = $(product).find('.prod_price');
        if($selectedColorSwatch.length) {
            if ($(product).data('pid') === data.filteredRecommandationProducts[index]['id']) {
                colorData = data.filteredRecommandationProducts[index]['colorData'];
            }
            $('body').trigger(':getColorData', {
                response:colorData, tileBody:product, priceContainer:$priceContainer, text:text, discountFlag:discountFlag
            });
        } else if ($selectedColorSwatch.length === 0){
            // if color variation is not available, show default price and clear promo text
            if (data && data.product && data.product.recommendation && data.product.recommendation.length) {
                for (var i=0; i<data.product.recommendation.length; i++) {
                    var recom = data.product.recommendation[i];
                    // show default price, it will also remove any text if rendered by swatch interaction
                    if (recom && (recom.type === 1 && recom.productID === $(product).data('pid'))) {
                        if (isSelected) {
                            showDefaultPrice(recom, product, $priceContainer);
                        }
                    }
                }
            }
        }

        var isVariant = $(this).attr('data-pid') === $(this).find('.product-id').text() ? false : true;
        var $productContainer = $(this).closest('.product.product-wrapper');
        updateButtonText(false, $productContainer, isVariant);
    });
}

//Show default price if recommendation color variation is not available and it has any previous swatch selected
function showDefaultPrice(recom, product, $priceContainer) {
    var pricesBycolorJSON = JSON.parse(recom.pricesByColor) && 'price' in JSON.parse(recom.pricesByColor) ? JSON.parse(recom.pricesByColor) : null;
    var price = pricesBycolorJSON.price;
    var rangePrice = pricesBycolorJSON.rangePrice;
    if (price) {
        $priceContainer.find('.price').remove();

        $('<div>').attr({
            class: 'price',
            'data-alt-price-title': 'Price:'
        }).prependTo($priceContainer);
        $('<div>').attr({
            class: 'confirmation-modal-price',
        }).appendTo($priceContainer.find('.price'));

        if (rangePrice && rangePrice.max && rangePrice.min && price.sales) {
            if (rangePrice.max.price > rangePrice.min.price && price.sales.value === rangePrice.min.price && price.sales.value < price.list.value) {
                // sales price - regular price range
                $('<span>').attr({
                    class: 'sales',
                }).text(price.sales.formatted).appendTo($priceContainer.find('.confirmation-modal-price')).after('\n');
                $('<span>').attr({
                    class: 'priceSeparator',
                }).text(' - ').appendTo($priceContainer.find('.confirmation-modal-price').after('\n'));
                $('<span>').attr({
                    class: 'list',
                }).text(rangePrice.max.priceFormatted).appendTo($priceContainer.find('.confirmation-modal-price'));
            } else if (rangePrice.max.price > rangePrice.min.price && price.sales.value === rangePrice.min.price && price.sales.value === price.list.value) {
                // regular price - regular price range
                $('<span>').attr({
                    class: 'list',
                }).text(price.list.formatted).appendTo($priceContainer.find('.confirmation-modal-price')).after('\n');
                $('<span>').attr({
                    class: 'priceSeparator',
                }).text(' - ').appendTo($priceContainer.find('.confirmation-modal-price')).after('\n');
                $('<span>').attr({
                    class: 'list',
                }).text(rangePrice.max.priceFormatted).appendTo($priceContainer.find('.confirmation-modal-price'));
            } else {
                // sale price with strike
                if (price.sales.value && price.list.value && price.sales.value < price.list.value) {
                    $('<span>').attr({
                        class: 'sales',
                    }).text(price.sales.formatted).appendTo($priceContainer.find('.confirmation-modal-price')).after('\n');
                    $('<span>').attr({
                        class: 'sr-only',
                    }).text('price reduced from').appendTo($priceContainer.find('.confirmation-modal-price')).after('\n');
                    $('<span>').attr({
                        class: 'list strike-through',
                    }).text(price.list.formatted).appendTo($priceContainer.find('.confirmation-modal-price'));
                } else {
                    $('<span>').attr({
                    class: 'list',
                    }).text(rangePrice.min.priceFormatted).appendTo($priceContainer.find('.confirmation-modal-price'));
                }
            }
        } else {
            $('<span>').attr({
            class: 'list',
            }).text(price.list.formatted).appendTo($priceContainer.find('.confirmation-modal-price'));
        }
    }
}

//For Match Set Recommendation Product Tile
function processMatchSetAttributeSelect(selectedValueUrl, $productContainer) {
    if (selectedValueUrl && $productContainer) {
        var addToCartButton = $productContainer.find('.js-match-set-add-to-cart');
        var attributeSelectDropdown = $productContainer.find('.match-set-item__variation .js-select-attr');

        addToCartButton.addClass('disable-button');
        attributeSelectDropdown.addClass('disable-select');

        return new Promise(function (resolve, reject) {
            $.ajax({
                url: selectedValueUrl,
                method: 'GET',
                success: function (data) {
                    updateOptions(data.product.optionsHtml, $productContainer);
                    
                    var updatePrice = true;
                    $productContainer.find('.match-set-item__variation select.js-select-attr').each(function(){
                    	if ($(this).val() == '') {
                    		updatePrice = false;
                    	}
                    });
                    
                    handleVariantResponse(data, $productContainer, updatePrice);
                    if (updatePrice) {
                    	$productContainer.find('.price').replaceWith(data.product.price.html);
                    }
                    addToCartButton.attr('data-pid', data.product.id).removeClass('disable-button');
                    attributeSelectDropdown.removeClass('disable-select');

                    $('body').trigger('product:afterAttributeSelect', {
                        data: data,
                        container: $productContainer
                    });
                    resolve(data);
                },
                error: function (err) {
                    addToCartButton.removeClass('disable-button');
                    attributeSelectDropdown.removeClass('disable-select');
                    reject(err);
                },
                complete: function() {
                    $.spinner().stop();
                }
            });
        });
    }
}

// For gridTileAddToCart product recs tile
function processTileAttributeSelect(selectedValueUrl, $productContainer) {
    if (selectedValueUrl && $productContainer) {
        var addToCartButton = $productContainer.find('.ptile-add-to-cart');
        $productContainer.spinner().start();

        return new Promise(function (resolve, reject) {
            $.ajax({
                url: selectedValueUrl,
                method: 'GET',
                success: function (data) {
                    updateOptions(data.product.optionsHtml, $productContainer);
                    handleVariantResponse(data, $productContainer, true);
                    $productContainer.find('picture source').attr('srcset', data.product.images.large[0].mobile);
                    $productContainer.find('picture img').attr('src', data.product.images.large[0].mobile);
                    $productContainer.find('.price').replaceWith(data.product.price.html);
                    $productContainer.find('.image-container a').attr('href', data.product.selectedProductUrl);
                    $productContainer.find('.item__content .item__name a.link').attr('href', data.product.selectedProductUrl);
                    addToCartButton.attr('data-pid', data.product.id);
                    $.spinner().stop();
                    resolve(data)
                },
                error: function (err) {
                    $.spinner().stop();
                    reject(err);
                }
            });
        });
    }
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl($productContainer) {
    return $productContainer.find('.add-to-cart-url').val();
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));
    var body = $html.find('.choice-of-bonus-product');
    var footer = $html.find('.modal-footer').children();

    return {
        body: body,
        footer: footer
    };
}

/**
 * Refresh match set carousel on addToCart modal
 */
function refreshMatchSetCarousel(hideAddCartModal) {
    var matchSetContainer = $('#addToCartModal').find('.js-match-set-container');
    startCarousel.initMatchSetCarousel();
    setTimeout(function () {
        matchSetContainer.find('.slick-slider').slick('refresh');
        if (hideAddCartModal === null || !hideAddCartModal) {
            matchSetContainer.find('select.selectpicker').selectpicker();
        }
    }, 500);
}

/**
 * Process color swatches of bonus products on the modal
 */
function processBonusProductSwatches(response) {
    // Keep OOS swatches disabled and unselectable
    $(response.body).find('.attributes button.color-attribute.unselectable').addClass('disabled unselectable');
    $(response.body).find('.attributes button.color-attribute.unselectable').prop('disabled', true);

    // Show color name if a swatch is auto-selected
    var $selectedSwatches = $(response.body).find('.attributes button.color-attribute.selected');
    if ($selectedSwatches.length) { 
        $selectedSwatches.each(function () {
            var $colorLabel = $(this).parents('.js-attribute').find('.js-label[data-pid="color"] .js-replace');
            var colorName = $(this).attr('data-displayValue').split(' ').slice(1).join(' ');
            $colorLabel.text(colorName);
        });
    }
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="bonus-choice-title">' + data.labels.selectprods + '</span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            // disable all OOS color swatches - make them unselectable, show color name if swatch is auto-selected
            processBonusProductSwatches(parsedHtml);
            startCarousel.initBonusProductCarouselHorizontal();
            setTimeout(function () {
                $('#chooseBonusProductModal .modal-body').find('.slick-slider').slick("refresh");
            }, 500);

            if ($('#addToCartModal').length) {
                $("#chooseBonusProductModal").on('hide.bs.modal', function() {
                    $('#addToCartModal').modal('show');
                    $('body').addClass('add-to-cart-modal-open');
                    refreshMatchSetCarousel(false);
                });
            }
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response, loc) {
    $('.js-minicart').trigger('count:update', response);
    var messageType = response.error ? 'alert-danger' : 'alert-success';
    var hideAddCartModal = false;
    var loc = loc;
    if (!loc) {
        loc = null;
    }

    // show add to cart toast
    if (response.newBonusDiscountLineItem && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        hideAddCartModal = true;
        addToCartModal(response, hideAddCartModal, loc);
        response.newBonusDiscountLineItem.labels.selectprods = $('.bonus-modal-title').val();
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else if (response.error) {
        if ($('.add-to-cart-messages').length === 0) {
            if ($('.modal') && $('.modal ').length > 0) {
                $('.modal').parent().append(
                    '<div class="add-to-cart-messages"></div>'
                );
            } else {
                $('body').append(
                    '<div class="add-to-cart-messages"></div>'
                );
            }
        }

        $('.add-to-cart-messages').append(
            '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">' +
            response.message +
            '</div>'
        );

        $('.limited-stock-error').remove();
        if ($('.page').data('action') === 'Product-Show' && !$('#quantity-select').parents('.modal').length) {
            $('.js-pdpQtyError').parent().remove();
        } else {
            $('.js-pdpQtyError').remove();
        }
        var $limitedStockError = '<div class="limited-stock-error"><i class="fa fa-exclamation-triangle" aria-hidde="true"></i>' + response.message + '</div>';
        $($limitedStockError).insertAfter('.prod-addToBag-wrapper');

        setTimeout(function () {
            $('.add-to-basket-alert').remove();
        }, 5000);
    } else {
        addToCartModal(response, hideAddCartModal, loc);
    }
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').text(),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
	var personalizationApplied = false;
    if ($('.data-embroidery').length > 0) {
    	$('.data-embroidery').each(function() {
    		if ($(this).val() != '' && JSON.parse($(this).val()).length > 0) {
    			personalizationApplied = true;
    		}
    	});
    }
    var options = $productContainer.find('.product-option').map(function () {
        var $elOption = $(this).find('.options-select');
        var urlValue = $elOption.val();
        var selectedValueId = (personalizationApplied || !$('.new-pdp-layout').length || $elOption.hasClass('js-Engraving'))
            ? $elOption.find('option[value="' + urlValue + '"]').data('value-id') : 'none';
        return {
            optionId: $(this).data('option-id'),
            selectedValueId: selectedValueId
        };
    }).toArray();

    return JSON.stringify(options);
}

/**
 * Shows Add to Cart Modal when a product is successfully added to cart
 */
function addToCartModal(data, hideAddCartModal, loc) {
    if ($('#addToCartModal').length !== 0) {
        $('#addToCartModal').remove();
    }
    var htmlString = '<!-- Modal -->' +
        '<div class="modal fade addToCartModal" id="addToCartModal" role="dialog" tabindex="-1" aria-label="Add to Cart Modal">' +
        '<span class="enter-message sr-only" ></span>' +
        '<div class="modal-dialog modal-lg add-to-cart-dialog">' +
        '<!-- Modal content-->' +
        '<div class="modal-content">' +
        '    <a class="full-pdp-link" href="" tabindex="-1"></a>' +
        '    <button type="button" class="close" data-dismiss="modal" aria-label="Close">' +
        '        <span aria-hidden="true">&times;</span>' +
        '        <span class="sr-only"> </span>' +
        '    </button>' +
        '<div class="modal-body"></div>' +
        '</div>' +
        '</div>' +
        '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $('#addToCartModal .modal-body').empty();
    $('#addToCartModal .modal-body').html(data.renderedTemplate);
    if (hideAddCartModal != null && !!hideAddCartModal) {
        $('#addToCartModal').modal('hide');
    } else {
        $('#addToCartModal').modal('show');
        $('body').addClass('add-to-cart-modal-open');
    }

    $.spinner().stop();
    $('.add-to-cart-dialog .button-continue, .add-to-cart-dialog button.close').on('click', function () {
        $('#addToCartModal').modal('hide');
        $('#addToCartModal').remove();
        $('.modal-backdrop').remove();
        $('body').removeClass('add-to-cart-modal-open');
        $('body').removeClass('modal-open');
        $('body').removeAttr('style');
        if ($('.bootstrap-select div.dropdown-menu.show').length > 0) {
            $('.bootstrap-select div.dropdown-menu.show').removeClass('show');
        }
    });

    $('#addToCartModal').on('hide.bs.modal', function () {
        if (loc == 'cart') {
           window.location.href = window.location.href;

        }
    });

    setTimeout(function () {
        $('body').find('#addToCartModal button.close').focus();
    }, 300);
    $('.addcart-recommendations').hide();
    $('.js-match-set-container').spinner().start();
    // Load product recs
    $.ajax({
        url: data.recommURL,
        method: 'GET',
        success: function (response) {
            if(!data.isMatchSet && response.includes('product-tile--simple')){
                $('.addcart-recommendations').show();
                $('.addcart-recommendations').append(response);
            } else {
            	$('.addcart-product .js-match-set-container').html(response.renderedTemplate);

            	refreshMatchSetCarousel(hideAddCartModal);
            }
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });

    klaviyoAddToCartEvent(data.klaviyoCartEvent);
}

function getUpdatedTotalData(updatedURL) {
    return new Promise(function (resolve, reject) {
        $.ajax({
            url: updatedURL,
            type: 'get',
            dataType: 'html',
            success: function success(updatedTotals) {
                resolve(updatedTotals);
            }
        });
    });
}

function validateAddOns() {
    var hasError = false;

    // Gift Card Email
    var giftCardEmail = $('.js-gcDataEmail');
    if (giftCardEmail && giftCardEmail.length > 0) {
        giftCardEmail.removeClass('is-invalid');
        giftCardEmail.siblings('.invalid-feedback').hide();
        var emailRegex = /^[a-zA-Z0-9!$%*=?^_`{|}~+-]+(?:\.[a-zA-Z0-9!$%*=?^_`{|}~+-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+(?:[a-zA-Z]{2,15})$/;
        var email = giftCardEmail.val();

        if (email) {
            var isValidEmail = emailRegex.test(email);
            if (!isValidEmail) {
                hasError = true;
                giftCardEmail.addClass('is-invalid');
                giftCardEmail.siblings('.invalid-feedback').show();

                return hasError;
            }
        }
    }

    // Notecard
    var notecard = $('.js-ncData');
    if (notecard && notecard.length > 0) {
        var notecardText = notecard.val();
        var maxlength = notecard.attr('maxlength') || 125;

        if (notecardText.length > 0 && (notecardText.length > maxlength)) {
            alert('Please limit to ' + maxlength + ' characters.');
            notecard.focus();
            hasError = true;
            return hasError;
        } else if (notecardText.length === 0) {
            alert('Please add a message.');
            notecard.focus();
            hasError = true;
            return hasError;
        }
    }

    // Engraving
    if ($('.engraving').length) {
        var primaryTextValue = $('.js-primary').length > 0 ? $('.js-primary').val() : '';
        var fontValue = $('select.js-engStyle').val();

        // if text field has value
        if (primaryTextValue.length > 0) {
            if (fontValue === 'none') {
                alert('Please Select A Personalization Style.');
                hasError = true;
                return hasError;
            }
        } else if (fontValue !== 'none') {
            // if text has no value and font is selected then reset to 'none'
            $('select.js-engStyle').val('none').trigger('change');
        }
    }

    // Embroidery
    var embroiderySet = $('.embroideryset');
    var productOptions = $('.product-option');
    if (embroiderySet && productOptions.length > 0) {
    	$.each(embroiderySet, function () {
            var currentSet = $(this);
            var embroideryString = currentSet.find('.data-embroidery').val();

            /* Check for option surcharges / VAS string */
            if (embroideryString.length > 2) {
                var embroideryData = JSON.parse(embroideryString);
                $.each(embroideryData, function (i, data) {
                	if(!data.isLogo) {
                		var errorMessage = '';
                		var position = 'locCode' in data ? currentSet.find('.js-position-change option:selected').val() : '';
                		if (position == '') {
                			errorMessage = 'Position';
                		} else if (data.color.indexOf("Select") > -1) {
                			errorMessage = 'Thread Color for ' + position;
                		} else if (data.font == 'block' && !hasError) {
                			errorMessage = 'font for ' + position;
	                    }
                		if (errorMessage != '') {
                			alert('Please Select a ' + errorMessage);
                			hasError = true;
                			return false;
                		}
                	}
                });
            }
        });
        if (!hasError) {
        	/* To hide embroidery section after add to cart button clicked */
        	$('.embroideryset').each(function() {
        		var set = $(this).data('set');
        		var finalData = $(".js-finalBuild-" + set + "-input").val();
        		if (finalData.length > 2 || localStorage.getItem('isLogoArtChecked' + set) == 'true') {
        			$('.embroideryset').hide();
        			$(".embroidery-set[data-set='" + set + "']").addClass('completed');
        			$('.embroidery-sets').show();
        		} else {
        			$('.js-remove-position[data-set="' + set + '"]').trigger("click");
        		}
        		$('html, body').animate({
                    scrollTop: $('.section-embroidery').offset().top -  $('#header-container').height()
                }, 'slow');
        	});
        	if ($('.embroidery-set.completed').length != $(".embroidery-set").length) {
        		$('.embroidery__addset__option').show();
        	}
        }
    }

    return hasError;
}

function getProductContainer(current, mainProduct) {
    var $productContainer = current.closest('.product-detail').find('.js-main-product');
    var $addOnContainer = current.closest('.js-productContainer');
    var $setContainer = current.closest('.set-item');
    var $coordinatingItemsContainer = current.closest('.coordinating-product');
    var $recsTileContainer = current.closest('.js-product-rec-tile');
    var $quickviewContainer = current.closest('.product-quickview');
    var $matchSetTileContainer = current.closest('.js-match-set-tile');
    var $reusableShopComponent = current.closest('.product.product-wrapper');
    var $bonusProductContainer = current.closest('.choice-of-bonus-product');

    if ($addOnContainer.length > 0) {
        $productContainer = $addOnContainer;
    } else if ($setContainer.length > 0) {
        $productContainer = $setContainer;
    } else if ($coordinatingItemsContainer.length > 0) {
        $productContainer = $coordinatingItemsContainer;
    } else if ($recsTileContainer.length > 0) {
        $productContainer = $recsTileContainer;
    } else if ($quickviewContainer.length > 0) {
        $productContainer = $quickviewContainer;
    } else if ($matchSetTileContainer.length > 0) {
        $productContainer = $matchSetTileContainer;
    } else if ((mainProduct && mainProduct.length < 1) && ($reusableShopComponent.length > 0)) {
        $productContainer = $reusableShopComponent;
    } else if ($bonusProductContainer.length > 0) {
        $productContainer = $bonusProductContainer;
    }

    return $productContainer;
}

function addAdditionalProduct(product) {
    var setPids = [];
    var checkbox = product.find('.item__checkbox__wrapper .checkmarkinput');
    if (checkbox.is(':checked')) {
        setPids.push({
            pid: product.find('.product-id').text(),
            qty: 1, // there's no qty display for add ons. Default to 1
            options: getOptions(product)
        });
    }

    return setPids;
}

function validateQuantity(quantityContainer) {
    var qtyValue = quantityContainer.val();
    var max = quantityContainer.attr('data-max');
    var pliMax = quantityContainer.attr('data-plimax');
    pliMax = parseInt(pliMax);
    max = parseFloat(max);

    if (qtyValue != max) {
        if ($('.page').data('action') === 'Product-Show' && !quantityContainer.parents('.modal').length) {
            $('.js-pdpQtyError').parent().remove();
        } else {
            $('.js-pdpQtyError').remove();
        }
        $('.limited-stock-error').remove();
        $('.pdp-gallery-section').removeClass('extended-top');
    }

    if (qtyValue > max) {
        if (max == 0) {
            quantityContainer.val(1); // set default to 1 when variant isn't selected
            quantityContainer.parents('.cart-item-qty').addClass('disabled').removeClass('enabled').find('> button, > input').prop('disabled', true);
        } else {
            var errorMessage = '';

            if (max >= pliMax) {
                quantityContainer.val(pliMax);
                errorMessage = "Sorry, only a quantity of " + pliMax + " can be added at a time. Please reduce the quantity and try again.";
            } else {
                var maxValue = parseFloat(max).toFixed();
                var message = "Items are in stock";
                if (max == 1) {
                    message = "Item is in stock";
                }
                quantityContainer.val(max);
                quantityContainer.closest('.main-product').find('.availability-msg').empty().text(maxValue + " " + message);
                errorMessage = "Only " + max + " item(s) available in stock.";
            }

            var errorHTML = '<div class="js-pdpQtyError alert alert-error" role="alert"> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i><span aria-hidden="true">' + errorMessage + '</span><span class="visually-hidden">'+ errorMessage.replace(/[()]/g, '') +'</span></div>';
            if ($('.page').data('action') === 'Product-Show' && !quantityContainer.parents('.modal').length) {
                errorHTML = '<div class="pdpQtyErrorMsg">' + errorHTML + '</div>';
            }
            quantityContainer.closest('.add-to-cart-cta').append(errorHTML);
            $('.pdp-gallery-section').addClass('extended-top');
        }
    }
}

function checkoutAddNotecardChecked(data, pid) {
    if ($('#checkout-main .js-addNotecard').length) {
        $('.js-addNotecard').prop('checked', true);
        $(".js-notecardPrice").removeClass('d-none');
        $('.js-addedNC-pid').val(pid);

        var items = data.cart.items;
        var addedProduct = items.filter(function (item) {
            return item.id === pid;
        });

        if (addedProduct && addedProduct[0]) {
            $('.js-addedNC-uuid').val(addedProduct[0].UUID);
        }
    }
}

function validateProductCustomFields() {
    // Gift Card and Handwritten Note Message fields
    $('.js-ncData, .js-gcDataMessage, .js-gcData').on('keyup paste', function () {
        $(this).val($(this).val().replace(/[^a-z0-9 -?!@]/gi, ''));
    });

    $('.js-gcDataEmail').on('keyup paste', function () {
        if ($(this).hasClass('is-invalid')) {
            $(this).removeClass('is-invalid');
            $(this).siblings('.invalid-feedback').hide();
        }
    });
}

function openNotifymeModel(res) {
    $('body').append(res.renderedTemplate);
    $('#notifymeModal').modal('show');
    $.spinner().stop();
}
/**
 * Process Add To Cart Logic
 * @param $this - Add To Cart Button's 'this' context
 */
function processAddToCart($this) {
    var addToCartUrl;
    var pid;
    var pidsObj;
    var setPids = [];
    var giftCardMessage;
    var giftCardDataRecipientEmail;
    var giftCardDataRecipientName;
    var embroideryData = [];
    var engravingData;
    var noteMessage;
    var quantity;
    var isEditPLI = $('.update-cart').data('uuid') && $('.update-cart').data('uuid').length > 0 ? true : false;
    var updateCartUUID = isEditPLI ? $('.update-cart').data('uuid') : '';
    var personalizationEligible = false;
    var addToCartBtn = $this;
    var isNotecard = $('.js-ncData').length;
    var isQuickView = $this.parents('#quickViewModal');
    var isLogoArtFeeProduct = false;

    try {
        addToCartBtn.addClass('btn-spinner');
        var isCheckout = false;

        if ($('h1').data('type') == "checkout-page") {
            isCheckout = true;
        }

        $('body').trigger('product:beforeAddToCart', this);

        if ($('.set-items').length && $this.hasClass('add-to-cart-global')) {
            $('.product-detail').each(function () {
                if (!$(this).hasClass('product-set-detail')) {
                    setPids.push({
                        pid: $(this).find('.product-id').text(),
                        qty: $(this).find('.quantity-select').val(),
                        options: getOptions($(this))
                    });
                }
            });
        }

        // Include Recommended Add-On Product(s)
        var addOnProducts = $('.rec-addons') ? $('.rec-addons').find('.product') : '';
        var coordinatingItems = $('.coordinating-items__details') ? $('.coordinating-items__details').find('.coordinating-product') : '';
        if (addOnProducts.length > 0) {
            addOnProducts.each(function () {
                var result = addAdditionalProduct($(this));
                setPids = $.merge(setPids, result);
            });
        }
        if (coordinatingItems.length > 0) {
            coordinatingItems.each(function () {
                var result = addAdditionalProduct($(this));
                setPids = $.merge(setPids, result);
            });
        }

        if (setPids.length > 0) {
            pidsObj = JSON.stringify(setPids);
        }

        pid = getPidValue($this);

        var $productContainer = $this.closest('.product-detail');
        if ($productContainer.find('.js-main-product').length > 0) {
            $productContainer = $productContainer.find('.js-main-product');
        }

        var isFromShopComp = ($productContainer.parents('.shop-component').length > 0);
        if (!$productContainer.length) {
            $productContainer = $this.closest('.quick-view-dialog').find('.product-detail');
        }

        if (getGiftCardStatus($this)) {
            giftCardMessage = $('.js-gcData.message').val();
            giftCardDataRecipientName = $('.js-gcData.name').val();
            giftCardDataRecipientEmail = $('.js-gcData.email').val();
        }

        // notecard data 401,,0.00,N,SCRIPT~Black~1/2~Beau
        if ($('.js-ncData').length) {
            if ($('.js-ncData.line1').val()) {
                noteMessage = { 'code': '801', 'price': "0.00", "text": $('.js-ncData.line1').val() }
                var data = [noteMessage]; // '[{...}]'
                engravingData = JSON.stringify(data);
            }
        }

        // Embroidery Data
        var embroideryInput = $productContainer.find('.data-embroidery');
        var allowsPersonalization = $this.closest('.product-second-col').find('.js-attributes .main-product .js-mainOptions');

        // Support quickview & Reusable shopping component
        if ((allowsPersonalization && allowsPersonalization.data('personalizable') == true) || ($productContainer.find('.personalizable').val() === 'true')) {
            personalizationEligible = true;
        }

        if (embroideryInput && embroideryInput.length > 0 && isQuickView.length == 0) {
            embroideryInput.each(function () {
                var embroidery = $(this).val();
                if (embroidery.length > 0 && JSON.parse(embroidery).length > 0) {
                	embroideryData.push(embroidery);
                }
            });

            embroideryData = JSON.stringify(embroideryData);
        }

        // Engraving Data here
        var engravingInput = $productContainer.find('.data-engraving');
        if (engravingInput && engravingInput.length > 0 && isQuickView.length == 0) {
            engravingData = engravingInput.val();
            engravingData = engravingData.replaceAll('$', '');
        }

        addToCartUrl = getAddToCartUrl($productContainer);

        // check if logoArtFee product is selected with parent product
        if ($this.parents('.js-main-product.pdp-main-container').length && !$this.parents('#quickViewModal').length) {
            $productContainer.find('.logoArtCheckbox .js-logoArtCheckbox').each(function () {
                if ($(this).val() === 'true') {
                    isLogoArtFeeProduct = true;
                }
            });
        }

        if ((pid.toLowerCase().indexOf('giftwrp') !== -1) || ($this.closest('.shop-component').length)) {
            quantity = 1;
        } else {
            quantity = getQuantitySelected($this);
        }

        var form = {
            pid: pid,
            pidsObj: pidsObj,
            childProducts: getChildProducts(),
            quantity: quantity,
            giftCardMessage: giftCardMessage,
            giftCardDataRecipientName: giftCardDataRecipientName,
            giftCardDataRecipientEmail: giftCardDataRecipientEmail,
            embroideryData: embroideryData,
            engravingData: engravingData,
            uuid: updateCartUUID,
            personalizationEligible: personalizationEligible,
            isLogoArtFeeProduct: isLogoArtFeeProduct
        };

        if ($productContainer.find('button.add-to-cart').attr('data-unavailable') === 'true') {
            form.isUnavailable = true;
        }

        if (!$('.bundle-item').length) {
            form.options = getOptions($productContainer.find('.main-product'));
        }

        $this.trigger('updateAddToCartFormData', form);

        if (addToCartUrl) {
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success: function (data) {
                    if (data.isUnavailable) {
                        openNotifymeModel(data);
                        addToCartBtn.removeClass('btn-spinner')
                        return 0;
                    }
                    if (data.isGiftWrapAlreadyInBasket) {
                        $('.gift-wrap-msg').removeClass('hide');
                        addToCartBtn.prop('disabled', true);
                        $this.closest('.product-second-col').find('.color-attribute').attr("disabled", "disabled");
                    }
                    if (data.error) {
                        handlePostCartAdd(data);
                        $.spinner().stop();
                        addToCartBtn.removeClass('btn-spinner');
                    } else {
                        if (isEditPLI && !isFromShopComp) {

                            var updateProductUuid = $('.update-cart').data('uuid');
                            localStorage.setItem("updateProductUuid", updateProductUuid);
                            // Redirect to Cart
                            window.location.href = data.cartShowURL;
                        } else {
                            $('body').trigger('product:afterAddToCart', data);

                            //if this is on the checkout page for the note, refresh the data for the items in cart and cart totals
                            if (isQuickView && isCheckout) {
                                getUpdatedTotalData($('.updated-data-url').val()).then(function (updatedTotals) {
                                    $(".order-product-summary-wrapper").html($(updatedTotals).filter(".order-product-summary.card"));
                                    $(".card-body.order-total-summary").html($(updatedTotals).filter(".card-body.order-total-summary"));
                                    $('.js-cart-count').empty().text(data.cart.numItems);

                                    if (isNotecard) {
                                        checkoutAddNotecardChecked(data, pid);
                                    }

                                    var grandTotalSum = $(updatedTotals).find('.js-grandTotalSum').text();
                                    var hasTotalRemaining = $(updatedTotals).find('.js-grandTotalSum').attr('data-remainingtotal');
                                    $('body').trigger(':handleNegativeTotal', {
                                        grandTotalSum: grandTotalSum,
                                        hasTotalRemaining: hasTotalRemaining
                                    });

                                    $.spinner().stop();
                                    addToCartBtn.removeClass('btn-spinner');
                                });
                            } else {
                                $.spinner().stop();
                                addToCartBtn.removeClass('btn-spinner');
                                handlePostCartAdd(data);
                            }
                        }
                    }
                },
                error: function (data) {
                    var errorMessage = 'Sorry, this could not be added to your cart.';
                    if (data && data.responseJSON && data.responseJSON.errorMessage) {
                        errorMessage = data.responseJSON.errorMessage;
                    }
                    var response = {
                        error: true,
                        message: errorMessage
                    };
                    handlePostCartAdd(response);
                    $.spinner().stop();
                    addToCartBtn.removeClass('btn-spinner');
                }
            });
        }
    } catch (error) {
        $.spinner().stop();
        addToCartBtn.removeClass('btn-spinner');
        console.error('Error while calling processAddToCart() : ' + error.toString());
    }
}

/**
 * Update upcharge price beside color or, size attribute
 * Check if an upcharge should display beside any pre-selected attribute
 */
function productUpchargeValues(upchargeValues, $productContainer) {
    $.each(upchargeValues, function (key, value) {
        var selectorClass = $productContainer.find(".js-" + value.attribute + "-upcharge");

        if (value.price) {
            if (value.price == "0.00" || value.price == "0") {
                $(selectorClass).html("");
                $(selectorClass).attr("content", 0);
            } else {
                $(selectorClass).html("<em>(+$" + value.price + ")</em>");
                $(selectorClass).attr("content", value.price);
            }
        } else {
            $(selectorClass).html("");
            $(selectorClass).attr("content", 0);
        }
    });
}


function refreshVariantDropDown(selector) {
    if ($(selector).length > 0) {
        $(selector).selectpicker('destroy');
        if ($(selector).next('button').length > 0) {
            $(selector).next('button').remove();
        }
        setTimeout(function () {
            $(selector).selectpicker();
        }, 500);
    }
}

function addAriaLabelsToDropdown() {
    setTimeout(function() {
        $('.selectpicker').siblings('.dropdown-toggle:not([aria-label])').each(function() {
            var $btn = $(this);
            $btn.attr('aria-label', ($btn.attr('title') || 'Select') + ' - Dropdown');
        });            
    }, 500)
}

$(document).ready(function () {

    addAriaLabelsToDropdown();

    const observer = new MutationObserver(function (mutations){
        mutations.forEach(function (mutation) {
            if(mutation.type === 'childList') {
                addAriaLabelsToDropdown();
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    })

    $('body').on('click', '.yotpo-nav-tab .yotpo-nav-wrapper', function (e) {
        scrollAnimate($('.ratingsReviews'));
    });

    // Tooltips
    $('.tip').each(function () {
        $(this).tooltip(
            {
                html: true,
                title: $('#' + $(this).data('tip')).html()
            });
    });

    // $(document).on('shown.bs.modal', '.modal', function (e) {
    //     $(e.target).focus();
    //     $(e.target).find('input[type!=hidden]:first').focus();
    // });

    setTimeout(function () { $('.js-p-carousel').slick('refresh'); }, 1000);

    $(".cart-recommendations select.selectpicker").val('').selectpicker("refresh");

    $('.attribute').each(function () {
        var selectedName = $(this).find('.selected').attr('title');
        if (selectedName == undefined) {
            selectedName = $(this).find('.selected').parent().attr('title');
        }
        var selectedFitStyle = $(this).attr('data-sizefitstyle');
        var selectedProduct = $(this).find('.selected').attr('data-attr');
        if (selectedProduct == undefined) {
            selectedProduct = $(this).find('.selected').parent().attr('data-attr');
        }
        if (selectedProduct != undefined) {
            var selectedProduct = selectedProduct.replace("-other", "");
        }
        var selectShortName = $(this).find('.selected').attr('data-attr-value');
        if (selectShortName == undefined) {
            selectShortName = $(this).find('.selected span').attr('data-attr-value');
        }
        if (selectShortName != undefined) {
            selectShortName = selectShortName.toUpperCase();
        }

        var $attrLabel = $(this).find(".js-label .js-replace");
        var newName = selectedName;

        if (selectedFitStyle && selectedProduct != undefined) {
            newName = "<span class='fitstyle'>" + selectedFitStyle + "</span> - " + newName;
        }

        // Removing the initial color code value
        if (selectedProduct && (selectedProduct.toLowerCase() == "color" || selectedProduct.toLowerCase().endsWith("color"))) {
            newName = newName.split(' ').slice(1).join(' ');
        }

        $attrLabel.html(newName);
    });

    validateProductCustomFields();

    $('.cart-footer .edit').on('click', function () {
        var selectedVariant = $(this).parents('.product-info').find('.quantity-input');
        var selectedVariantPid = $(selectedVariant).data('pid');
        var selectedVariantQty = parseInt($(selectedVariant).val());
        localStorage.setItem("currentProdId", selectedVariantPid);
        localStorage.setItem("initialProdQty", selectedVariantQty);
    });

    $(document).find('.save-for-later-link').off('click').on('click', function () {
        $(this).closest('.product-info').find('.cart-footer button.save-later').trigger('click');
    });

    $(document).on("keyup click", function (e) {
        if( e.which == 9 ) {
            if ($(document.activeElement).hasClass('add-to-cart')) {
                $(document.activeElement).closest('.add-to-cart-cta').addClass('focus-active');
            } else {
                $('.add-to-cart-cta').removeClass('focus-active');
            }
        }

        if( e.type == 'click' ) {
            if ($(document.activeElement).hasClass('add-to-cart')) {
                $(document.activeElement).closest('.add-to-cart-cta').addClass('focus-active');
            } else {
                $('.add-to-cart-cta').removeClass('focus-active');
            }
        }
    });

    $(document).on('click', '.edit-item-link a.edit', function () {
        $(this).closest('.product-info').find('.cart-footer a.edit').trigger('click');
    });

    $(document).on('click', '.embroidery-container button.embroidery-toggle', function () {
        if ($(this).closest('.js-savedItem-card').hasClass('activespace')) {
            $(this).closest('.js-savedItem-card').removeClass('activespace');
        } else {
            $(this).closest('.js-savedItem-card').addClass('activespace');
        }
    });

    $(document).on("hidden.bs.modal", '#addToCartModal', function() {
        $('#addToCartModal').find('.close').trigger('click');
    });

    $(window).scroll(function (e) {
        if ($(window).width() > 1300 && $(window).height() > 900) {
            let footerHeight = $('footer').height();
            let headerHeight = $('#header-container').height() + 15;
            if ($('header .bx-creative') && $('header .bx-creative').length) {
                headerHeight = headerHeight + $('header .bx-creative').height();
            }
            var footerScrollTop = footerHeight / 2;
            $('#cart-right-section').css('width', $('#cart-right-section').closest('div').width());
            $('#cart-right-section').css('top', headerHeight);
            if (($('footer').offset() !== undefined) && ($(window).height() + $(window).scrollTop() - (footerScrollTop) < $('footer').offset().top)) {
                $('#cart-right-section').addClass('fixed');
            } else {
                $('#cart-right-section').removeClass('fixed');
                $('#cart-right-section').removeAttr('style');
            }
        }
    });

    $(window).on('resize orientationchange', function () {
        if ($(window).width() < 1239 && $('#cart-right-section').length > 0) {
            $('#cart-right-section').removeAttr('style');
            $('#cart-right-section').removeClass('fixed');
        }
        if ($('#addToCartModal.show').length > 0) {
            $('#addToCartModal.show  select').selectpicker('destroy');
            setTimeout(function () {
                $('#addToCartModal.show   select').addClass('selectpicker').selectpicker('refresh');
            }, 300);
        }
    });

    $(window).on('orientationchange', function () {
        if ($(window).width() < 1239) {
                refreshVariantDropDown('#addToCartModal select.variant-picker')
        }
    });
    
    $(document).on('shown.bs.modal', '#addToCartModal', function (e) {
        $('#addToCartModal').on('scroll', function () {
            if ($('#addToCartModal .slick-active .dropup.show').length > 0) {
                $('#addToCartModal .slick-active .dropup.show button').trigger('click');
            }
        })
    })

    $('.product-message-text').off('click').on('click', function(e) {
        e.preventDefault();

        if (!$(this).closest('.product-message-section').hasClass('modal-exist')) {
            return false;
        }
        var $curObj = $(this);
        var $descriptionContent = $curObj.closest('.product-message-section').find('.product-message-modal-container');
        if ($($descriptionContent).hasClass('active')) {
            $($descriptionContent).removeClass('active');
            if ($('.modal.fade.show').length > 0) {
                $('body, html, .prod-addToBag-wrapper').removeClass('modal-open');
                $('.prod-addToBag-wrapper').removeClass('service-modal-open');
                $('#header-container').removeAttr('style');
                $('.modal.fade.show').remove();
            }
        } else {
            $($descriptionContent).addClass('active');            
            if ((($(window).scrollTop() + $(window).innerHeight()) - $('.product-message-section.modal-exist').offset().top) < 200) {
                $($descriptionContent).addClass('lowerDesktop-align');
            }  else {
                 $($descriptionContent).removeClass('lowerDesktop-align');
            }
            $('body').addClass('modal-open');
            $('.prod-addToBag-wrapper').addClass('service-modal-open');
            if ($(window).width() < 768) {
                $('html').addClass('modal-open');
            }

            $('<div>', {
                id: 'product-message-fade-bg',
                class: 'modal fade show',
                title: ''
            }).appendTo('.pdp-main-container');
            setTimeout(function () {
                $($descriptionContent).find('.product-message-modal-close').focus();
            }, 500);
        }
    });

    $(document).on('keyup',function(evt) {
        if (evt.keyCode == 27 && $('.product-message-modal-container').hasClass('active')) {
           $('.product-message-modal-container.active button').trigger('click');
        }
    });

    $(document).on('click', '.product-message-modal-container.active button', function (e) {
        e.preventDefault();
        var $curObj = $(this).closest('.product-message-modal-container');
        $curObj.removeClass('active');
        if ($('.modal.fade.show').length > 0) {
            $('body, html').removeClass('modal-open');
            $('.modal.fade.show').remove();
        }
    });

    $(document).on('click', '.modal.fade.show, .helpButtonEnabled', function () {
        $('.product-message-modal-container.active button').trigger('click');
    });

    $(window).on('load', function () {
        //check if an upcharge should display beside any pre-selected attribute
        let upchargeValues = [
            { 'attribute': 'color', 'price': $('.js-variationUpchargeByColor').val() },
            { 'attribute': 'size', 'price': $('.js-variationUpchargeBySize').val() }
        ];

        // Update upcharge price for main product on page load (the PDP of a variant product with an upcharge value)
        var mainProductContainer = $('.product-detail').find('.js-main-product');
        var $productContainer = getProductContainer(mainProductContainer, null);
        productUpchargeValues(upchargeValues, $productContainer);

        if ($('.product-message-section').find('.product-message-modal-container .text').length > 0) {
            $('.product-message-section').find('.product-message-modal-container .text').each(function() {
                if ($(this).text().trim().length > 0) {
                    $(this).closest('.product-message-section').addClass('modal-exist');
                }
            })
        }
    });

    $(document).on('keydown', '.pdp-carousel-nav-vertical', function () {
        if (!$(this).find('.slick-arrow').length) {
            var $productSlider = $(this).find('.prod-slider__item');
            $productSlider.each(function () {
                $(this).removeAttr('tabindex');
            });
        }
    });

    $(document).on("keydown", ".close-btn:focus, .product-message-text", function (e) {
        if ((e.key == "Enter" || e.keyCode == 13) && $(e.currentTarget).closest('.product-message-section').find('.product-message-modal-container').hasClass('active') == false) {
            $(this).trigger('click');
        }
    });

    $(document).on("keydown", ".product-message-modal-container.active .product-message-modal-close", function (e) {
        if ((e.keyCode == 40 || e.keyCode == 38 || e.keyCode == 9) || (e.keyCode === 9 && e.shiftKey)) {
            e.preventDefault();
            $(e.currentTarget).closest('.product-message-modal-container.active  .product-message-modal-close').focus();
        }
    });

    $('body').on('hidden.bs.modal', "#notifymeModal", function () {
        $(this).remove();
        //Required in case of quickview modal as two modals are opened together
        if ($('#quickViewModal').hasClass('show')) {
            $('body').addClass('modal-open');
        }
    });

    $('body').on('click touchend', '.selected-bonus-products .fa-times', function (e) {
        if ($('.selected-bonus-products .bonus-summary').hasClass('alert-danger')) {
            $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
        }
    });
});

module.exports = {
    attributeSelect: attributeSelect,
    addToCartModal: addToCartModal,
    getProductContainer: getProductContainer,
    addAriaLabelsToDropdown: addAriaLabelsToDropdown,

    methods: {
        editBonusProducts: function (data) {
            chooseBonusProducts(data);
        }
    },

    focusChooseBonusProductModal: function () {
        $('body').on('shown.bs.modal', '#chooseBonusProductModal', function () {
            $('#chooseBonusProductModal').siblings().attr('aria-hidden', 'true');
            $('#chooseBonusProductModal .close').focus();
        });
    },

    onClosingChooseBonusProductModal: function () {
        $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
            $('#chooseBonusProductModal').siblings().attr('aria-hidden', 'false');
            if ($('#chooseBonusProductModal').length !== 0) {
                $('#chooseBonusProductModal').remove();
            }
        });
    },

    trapChooseBonusProductModalFocus: function () {
        $('body').on('keydown', '#chooseBonusProductModal', function (e) {
            var focusParams = {
                event: e,
                containerSelector: '#chooseBonusProductModal',
                firstElementSelector: '.close',
                lastElementSelector: '.add-bonus-products'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },

    colorAttribute: function () {
        $(document).on('click', '[data-attr$="olor"] button, [data-attr$="COLORS"] button', function (e) {
            e.preventDefault();
            var dataUrl = $(this).attr('data-url');
            $(this).focus();
            $(this).addClass('colorSwatchSelected');
            if ($(this).attr('disabled') || dataUrl == undefined) {
                return;
            }
            // once attribute selected, it can not be deselected
            if ($(this).hasClass('selected')) {
                return false;
            }
            var isMainProduct = $(this).closest('.product-detail').find('.js-main-product');
            var $productContainer = getProductContainer($(this), isMainProduct);
            $('body').trigger('product:beforeAddToCart', this);

            if (!$('body').hasClass('swatchSelected')) {
                $('body').addClass('swatchSelected');
            }

            // get full color name that contains color family
            // only get the color name and do the backend processing if swatch click is originated from main product section
            // backend processing is not needed for swatch selection done from recommendations
            var fullcolorname = null;
            var mainProdSwatchClicked = !$(this).parents('section').hasClass('rc-shop-container') && $(this).parents('.bonus-product-item').length === 0;
            if ($(this).parents('section').length && mainProdSwatchClicked) {
                fullcolorname = $(this).attr('data-fulldisplayvalue');
            }

            attributeSelect($(this).attr('data-url'), $productContainer, e, fullcolorname, mainProdSwatchClicked);
        });
    },

    themeAttribute: function () {
        $(document).on('click', 'button[data-attr="Theme"]', function (e) {
            e.preventDefault();

            if ($(this).attr('disabled')) {
                return;
            }

            $productContainer = $(this).closest('.product-detail').find('.main-product');

            attributeSelect($(this).attr('data-url'), $productContainer);
        });
    },

    giftWrap: function () {
        $(document).on('click', 'button[data-attr="GiftWrapSelection"]', function (e) {
            e.preventDefault();
            if ($(this).attr('disabled')) {
                return;
            }

            $productContainer = $(this).closest('.product-detail').find('.main-product');

            attributeSelect($(this).attr('data-url'), $productContainer);
        });
    },

    otherAttribute: function () {
        $(document).on('click', 'button[data-attr$="other"]', function (e) {
            e.preventDefault();

            if ($(this).attr('disabled')) {
                return;
            }

            // once attribute selected, it can not be deselected
            if ($(this).hasClass('selected')) {
                return false;
            }

            var isMainProduct = $(this).closest('.product-detail').find('.js-main-product');
            var $productContainer = getProductContainer($(this), isMainProduct);

            $('body').trigger('product:beforeAddToCart', this);

            if (!$('body').hasClass('swatchSelected')) {
                $('body').addClass('swatchSelected');
            }

            // add color variation if recommendation product has color is selected
            if ($(this).parents('.product').find('.swatch-circle.selected').length > 0) {
                var variationUrl = '';
                var pid = $(this).parents('.product.product-detail').attr('data-pid');
                var color = $(this).parents('.product').find('.swatch-circle.selected').closest('span').length > 0 ? $(this).parents('.product').find('.swatch-circle.selected').closest('span').attr('data-attr-value') : null;
                variationUrl = color!==null ? $(this).attr('data-url') + '&dwvar_' + pid + '_color=' + color : null;
            }
            if (variationUrl) {
                attributeSelect(variationUrl, $productContainer, e);
            } else attributeSelect($(this).attr('data-url'), $productContainer, e);
        });
    },

    selectAttribute: function () {
        $(document).on('change', 'select[class*="select-"], .options-select', function (e) {
            e.preventDefault();
            var $productContainer = getProductContainer($(this), null);
            // Select only for valid product variation URL
            if (e.currentTarget.value.indexOf('Product-Variation') !== -1) {
                attributeSelect(e.currentTarget.value, $productContainer);
            } else if ($(this).parents('.coordinating-product').length > 0) {
            	if (e.currentTarget.value.indexOf('select') > -1) {
            		$(this).parents('.coordinating-product').find('.js-items-attr .selected.selectable').removeClass('selected');
            		var $productContainer = $(this).closest('.product-detail').find('.main-product');
                	validateAddToCartButton($productContainer);
            	}
            }
        });

        if ($('.js-sizeAsDropdown').length) {
            $('.js-sizeAsDropdown #nonswatch-select').on('changed.bs.select', function (e) {
                var currentElement = $(e.currentTarget);
                currentElement.find('option').removeAttr('selected');
                var selected = currentElement.val();
                var itemVariation = $(this).closest('.js-items-attr');
                if (itemVariation.find(".variant-value.selected, .selection-button.selected").data('attr-value') !== selected) {
                    if (selected != '') {
                        itemVariation.find("[data-attr-value='" + selected + "']").closest('.selectable').click();
                    } else {
                        // unselect current attribute
                        var thisAttrButton = $(this).closest('.js-attribute').find('.js-items-attr button.selected');
                        if (thisAttrButton) {
                            thisAttrButton.click();
                        }
                    }
                }
            });
        }
    },

    availability: function () {
        $(document).on('change input', '.quantity-select', debounce(function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest('.product-detail').find('.main-product');;
            var $addOnContainer = $(this).closest('.rec-addons');
            if (!$productContainer.length && $addOnContainer.length === 0) {
                $productContainer = $(this).closest('.modal-content').find('.product-quickview');
            }

            var isQuantityValid = true;
            if ($(this).val != 1) {
                validateQuantity($(this));
            }

            if ($('.bundle-items', $productContainer).length === 0 && isQuantityValid === true) {
                // fetch the data-href and update qty
                var selectedUrl = $productContainer.find('.js-quantityCard').attr('data-href');
                var updatedQty = $(this).closest('.quantity-select').val();
                if (selectedUrl !== undefined && updatedQty) {
                    var updatedUrl = selectedUrl.split('&quantity=')[0] + '&quantity=' + updatedQty;
                    attributeSelect(updatedUrl, $productContainer);
                }
            }
        }, 500));

        $(document).on('keyup', '#quantity-select', function () {
            var _this = $(this);
            var minQty = parseInt(_this.attr('min')) || 1;
            var qty = parseInt(_this.val()) || (minQty - 1);

            if (qty < minQty) {
                _this.val(minQty);
            }

        });

        if ($('.page[data-action="Cart-GetProduct"]').length > 0) {
            $('.quantity-select').trigger('change');
        }

        validateQuantity($('.quantity-select'));
    },

    addToCart: function () {
        $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', function (e) {
            var $this = $(this);
            var addToCartBtn = $this;

            addToCartBtn.addClass('btn-spinner');
            addToCartBtn.focus();
            var isQuickView = $(this).parents('#quickViewModal');
            var isRCProduct = $(this).parents('.rc-shop-container');
            var isNonPersonalizedSection = (isQuickView.length > 0) || (isRCProduct.length > 0);

            if (isNonPersonalizedSection) {
                processAddToCart($this);
            } else {
                var hasAddonError = validateAddOns(); // Validate engraving/embroidery/notecard selections

                if (!hasAddonError) {
                	processAddToCart($this);
                } else {
                    addToCartBtn.removeClass('btn-spinner');
                }
            }
        });

    },

    notifyMe: function () {
    	$(document).on('click', '.js-keep-update', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $notifyModal = $('#notifymeModal');
            var form = $this.parents('form');
            var email = form.find('#notifyme-email');
            email.removeClass('is-invalid');
            email.next('.invalid-feedback').html('');
            if (!email[0].checkValidity()) {
                email.addClass('is-invalid');
                var validity;
                var validityStatus;
                for (var x in email[0].validity) {
                    validity = email[0].validity[x];
                    if (validity) {
                        validityStatus = x;
                        break;
                    }
                }
                if (validityStatus === 'patternMismatch') {
                    email.next('.invalid-feedback').html(email.attr('data-pattern-error'));
                } else if (validityStatus === 'valueMissing') {
                    email.next('.invalid-feedback').html(email.attr('data-required-error'));
                } else {
                    email.next('.invalid-feedback').html(email[0].validationMessage);
                }
                email.focus();
                return;
            }
            var data = form.serialize();
            var url = form.attr('action');
            var submitButton = form.find('button[type="submit"]');
            submitButton.addClass('btn-spinner');
            $.ajax({
                url: url,
                method: 'POST',
                data: data,
                success: function (data) {
                	form.find('.email-section').remove();
                    if (data.success) {
                        submitButton.removeClass('btn-primary, btn-spinner')
                        			.addClass('btn-outline-primary')
                        			.attr('disabled', 'disabled')
                        			.text(data.message);
                        $('.modal-content').focus();
                    } else {
                    	form.remove();
                    	$notifyModal.find('hr').remove();
                    	$notifyModal.find('.model-text-content').text(data.message);
                    	$notifyModal.find('.modal-title').text(data.title);
                        $('.modal-content').focus();

                    }
                },
                error: function (err) {
                    alert(err.responseJSON.error ? err.responseJSON.error.errorText : ('An error occurred' + err));
                    submitButton.removeClass('btn-spinner');
                }
            });
        });
    },

    updateQuantity: function () {
        $('body').on('click', '.js-quantityContainer .qtybutton', function () {
            var increment = $(this).data('increment');
            var qtyInput = $(this).closest('.js-quantityContainer').find('.quantity-input');
            var qtyValue = qtyInput.val();
            var allAttributeSelected = true;

            if (increment === 'up') {
                qtyValue = parseInt(qtyValue) + 1;
                qtyInput.val(qtyValue).trigger('change');

                $('.qtybutton').attr('aria-label', 'Increase quantity by 1 button. Current quantity is ' + qtyValue);
            } else {
                qtyValue = parseInt(qtyValue) - 1;
                if (qtyValue > 0) {
                    qtyInput.val(qtyValue).trigger('change');

                    $('.qtybutton').attr('aria-label', 'Decrease quantity by 1 button. Current quantity is ' + qtyValue);
                }
            }
            var $productContainer = $(this).closest('.product-detail').find('.js-main-product');
            var isQuickView = $(this).closest('.product-detail').hasClass('product-quickview');
            if (!isQuickView) {
                $productContainer.find('.js-attributes .attribute').not('.engraving').each(function () {
                    //checks if all attributes are selected
                    if ($(this).find('button.selected').length === 0) {
                        allAttributeSelected = false;
                    }
                });
                if (allAttributeSelected) {
                    updateTextForAddToBagButton(isQuickView, $productContainer, true);
                }
            }
        });
    },

    scrollUpdatedProductCard: function () {
        var updateProductUuid = localStorage.getItem("updateProductUuid");
        if (updateProductUuid) {
            $(window).on('load', function () {
                if ($(document).find('.card.product-info.uuid-' + updateProductUuid) .length > 0) {
                    var topOffset = $(document).find('.card.product-info.uuid-' + updateProductUuid).offset().top;
                    var isBelowTablet = false;

                    if ($(window).width() < 768) {
                        isBelowTablet = true;
                    } else {
                        isBelowTablet = false;
                    }

                    $('html, body').animate({
                        scrollTop: (topOffset - (isBelowTablet ? 150 : 130))
                    }, 1000);
                }
                localStorage.removeItem("updateProductUuid");
                localStorage.removeItem("currentProdId");
                localStorage.removeItem("initialProdQty");
            });
        }
    },

    textareaCharacterCounter: function () {
        if ($('.js-character-counter').length) {
            var textarea = $('.js-character-counter');
            var maxchars = textarea.attr('maxlength');
            var currentLength = textarea.val().length;
            var remain = currentLength + "/" + maxchars;
            $('.js-character-counter-remain').text(remain);

            $('.js-character-counter').keyup(function () {
                var remain = $(this).val().length + "/" + maxchars;
                $('.js-character-counter-remain').text(remain);
            });
        }
    },

    submitYotpoReview: function () {
        $('body').on('click', '.yotpo-new-review-submit', function () {
            yotpoWidgetsContainer.initWidgets();
        })
    },

    selectBonusProduct: function () {
        $(document).on('click', '.select-bonus-product', function () {
            var $choiceOfBonusProduct = $(this).parents('.choice-of-bonus-product');
            var pid = $(this).closest('.bonus-product-col').find('.product-id').html();
            var maxPids = $('.choose-bonus-product-dialog').data('total-qty');
            var submittedQty = parseInt($choiceOfBonusProduct.find('.bonus-quantity-select').val(), 10);
            var totalQty = 0;
            $.each($('#chooseBonusProductModal .selected-bonus-products .selected-pid'), function () {
                totalQty += $(this).data('qty');
            });
            totalQty += submittedQty;
            var optionID = $choiceOfBonusProduct.find('.product-option').data('option-id');
            var valueId = $choiceOfBonusProduct.find('.options-select option:selected').data('valueId');
            if (totalQty <= maxPids) {
                var selectedBonusProductHtml = ''
                + '<div class="selected-pid row align-items-center" '
                + 'data-pid="' + pid + '"'
                + 'data-qty="' + submittedQty + '"'
                + 'data-optionID="' + (optionID || '') + '"'
                + 'data-option-selected-value="' + (valueId || '') + '"'
                + '>'
                + '<div class="col-11 bonus-product-name" >'
                + $choiceOfBonusProduct.find('.product__name').html()
                + '</div>'
                + '<div class="col-1 p-0" aria-label="Remove selected bonus product"><i class="fa fa-times" aria-hidden="true"></i></div>'
                + '</div>';
                $('#chooseBonusProductModal .selected-bonus-products .bonus-summary').after(selectedBonusProductHtml);
                $('.pre-cart-products').html(totalQty);
                $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
            } else {
                $('.selected-bonus-products .bonus-summary').addClass('alert-danger');
            }

            // Scroll to add to cart button when user clicks on select button for bonus product
            const targetElement = $('.selected-bonus-products .bonus-summary');
            if (targetElement.length) {
                targetElement[0].scrollIntoView();
            }
        });
    },

    removeBonusProduct: function () {
        $(document).on('click', '.selected-pid', function () {
            $(this).remove();
            var $selected = $('#chooseBonusProductModal .selected-bonus-products .selected-pid');
            var count = 0;
            if ($selected.length) {
                $selected.each(function () {
                    count += parseInt($(this).data('qty'), 10);
                });
            }

            $('.pre-cart-products').html(count);
        });
    },

    enableBonusProductSelection: function () {
        $('body').on('bonusproduct:updateSelectButton', function (e, response) {
            $('button.select-bonus-product', response.$productContainer).attr(
                'disabled', (!response.product.readyToOrder || !response.product.available)
            );
            var pid = response.product.id;
            $('button.select-bonus-product', response.$productContainer).data('pid', pid);
            $('.product-id', response.$productContainer).text(pid);
        });
    },

    showMoreBonusProducts: function () {
        $(document).on('click', '.show-more-bonus-products', function () {
            var url = $(this).data('url');
            $('.modal-content').spinner().start();
            $.ajax({
                url: url,
                method: 'GET',
                success: function (html) {
                    var parsedHtml = parseHtml(html.renderedTemplate);
                    $('#chooseBonusProductModal .modal-body').append(parsedHtml.body);
                    $('.show-more-bonus-products:first').remove();
                    startCarousel.initBonusProductCarouselHorizontal();
                    $('#chooseBonusProductModal .modal-content').spinner().stop();
                },
                error: function () {
                    $('.modal-content').spinner().stop();
                }
            });
        });
    },

    addBonusProductsToCart: function () {
        $(document).on('click', '.add-bonus-products', function () {
            var $readyToOrderBonusProducts = $('.choose-bonus-product-dialog .selected-pid');
            var queryString = '?pids=';
            var url = $('.choose-bonus-product-dialog').data('addtocarturl');
            var pidsObject = {
                bonusProducts: []
            };
            var selectedProductCount = $('.choose-bonus-product-dialog').find('.pre-cart-products').text();     //need to check

            if (selectedProductCount == "0") {
                alert('Please select a gift item.');
                return;
            }

            $.each($readyToOrderBonusProducts, function () {
                var qtyOption = parseInt($(this)
                    .data('qty'), 10);

                var option = null;
                if (qtyOption > 0) {
                    if ($(this).data('optionid') && $(this).data('option-selected-value')) {
                        option = {};
                        option.optionId = $(this).data('optionid');
                        option.productId = $(this).data('pid');
                        option.selectedValueId = $(this).data('option-selected-value');
                    }
                    pidsObject.bonusProducts.push({
                        pid: $(this).data('pid'),
                        qty: qtyOption,
                        options: [option]
                    });
                    pidsObject.totalQty = parseInt($('.pre-cart-products').html(), 10);
                }
            });
            queryString += JSON.stringify(pidsObject);
            queryString = queryString + '&uuid=' + $('.choose-bonus-product-dialog').data('uuid');
            queryString = queryString + '&pliuuid=' + $('.choose-bonus-product-dialog').data('pliuuid');
            $.spinner().start();
            $.ajax({
                url: url + queryString,
                method: 'POST',
                success: function (data) {
                    $.spinner().stop();
                    if (data.error) {
                        $('#chooseBonusProductModal').modal('hide');
                        if ($('.add-to-cart-messages').length === 0) {
                            $('body').append('<div class="add-to-cart-messages"></div>');
                        }
                        $('.add-to-cart-messages').append(
                            '<div class="alert alert-danger add-to-basket-alert text-center"'
                            + ' role="alert">'
                            + data.errorMessage + '</div>'
                        );
                        setTimeout(function () {
                            $('.add-to-basket-alert').remove();
                        }, 3000);
                    } else {
                        $('.configure-bonus-product-attributes').html(data);
                        $('.bonus-products-step2').removeClass('hidden-xl-down');
                        $('#chooseBonusProductModal').modal('hide');

                        if ($('.add-to-cart-messages').length === 0) {
                            $('body').append('<div class="add-to-cart-messages"></div>');
                        }
                        $('.minicart-quantity').html(data.totalQty);
                        $('.add-to-cart-messages').append(
                            '<div class="alert alert-success add-to-basket-alert text-center"'
                            + ' role="alert">'
                            + data.msgSuccess + '</div>'
                        );
                        setTimeout(function () {
                            $('.add-to-basket-alert').remove();
                            if ($('.cart-page').length) {
                                location.reload();
                            }
                        }, 1500);
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    getPidValue: getPidValue,
    getQuantitySelected: getQuantitySelected,
    handlePostCartAdd: handlePostCartAdd,
    getOptions: getOptions,
    buildOptionsURL: buildOptionsURL,
    validateAddToCartButton: validateAddToCartButton,
    validateProductCustomFields: validateProductCustomFields,
    updateButtonText: updateButtonText,
    addToBagTextChange: addToBagTextChange,
    productUpchargeValues: productUpchargeValues,
    klaviyoAddToCartEvent: klaviyoAddToCartEvent
};